import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { cloudStorage } from "@tma.js/sdk-react";

const LANGUAGE_STORAGE_KEY = "app_language";

export const SALE_LANGUAGE_OPTIONS = [
  { value: "Kh", code: "kh", label: "ខ្មែរ", icon: "🇰🇭" },
  { value: "En", code: "en", label: "English", icon: "🇬🇧" },
  { value: "Ch", code: "ch", label: "中文", icon: "🇨🇳" },
];

const leadTranslations = {
  en: {
    attachment: "Attachment",
    saleDepositAttachment: "Deposit attachment",
    paymentAttachmentInvalid: "Choose a JPG, PNG, WEBP image or a PDF receipt.",
    paymentAttachmentDenied: "Upload denied. Your account needs permission to upload files.",
    paymentAttachmentUploading: "Uploading receipt…",
    paymentAttachmentOpen: "Open attachment",
    paymentAttachmentEmpty: "Add a payment receipt",
    paymentAttachmentHint: "JPG, PNG, WEBP or PDF · Optional",
    paymentAttachmentReplace: "Replace receipt",
    paymentAttachmentUpload: "Upload receipt",
    salePaymentEdit: "Edit payment", salePaymentAmount: "Amount", salePaymentDate: "Payment date", salePaymentReceivedBy: "Received by", salePaymentReceivedDate: "Received date", salePaymentInvalid: "Check the payment amounts and dates before saving.",
    saleFinalPaymentAttachment: "Final payment attachment",
    attachmentImagePreview: "Preview image",
    mySales: "My Sales",
    selectEventTypeBeforePlan: "Select an event type first to filter by plan.",
    filterPlansLoadError: "Unable to load plans.",
    eventDate: "Event Date",
    saleEventDateRequired: "Event Date is required.",
    saleEventDateInvalid: "Select a valid Event Date and time.",
    saleEventDateAscending: "Event Date: earliest first",
    saleEventDateDescending: "Event Date: latest first",
    timeHour: "Hour (24h)",
    timeMinute: "Minute",
    dateTimeInputInvalid: "Enter a valid date/time using {{format}} (24-hour time).",
    audioRecording: { hint: "Images, PDF or recorded audio · Up to 30 files", start: "Record audio", starting: "Opening microphone…", stop: "Stop & attach", recording: "Recording… Stop to upload and attach this recording.", unsupported: "Audio recording is unavailable in this browser.", permission: "Unable to open the microphone. Allow microphone access and try again.", failed: "Unable to attach the recording. Please try again.", invalidAttachment: "Choose up to 30 image, PDF or recorded audio attachments.", preview: "Conversation audio recording", retry: "Retry audio upload" },
    upcoming: { dueSales: "Due Sale Follow up", followUpSales: "Pre-Event Follow-Up", title: "Upcoming", sales: "Upcoming due sales ({{days}} days)", leads: "Upcoming events ({{days}} days)", loading: "Loading upcoming settings", error: "Unable to load upcoming settings.", precedence: "The selected due date or Today filter takes precedence over Upcoming." },
    globalConfig: {
      title: "Setting", upcomingFilters: "Upcoming filters",
      saleDueWithinDays: "Sale due within (days)", eventWithinDays: "Event within (days)",
      invalid: "Enter a whole number: {{limit}}", notFound: "Upcoming filters configuration was not found. Contact an administrator, then retry.",
      readOnly: "Only administrators can edit these settings.", loading: "Loading configuration", loadError: "Unable to load configuration. Access permission may be required.",
      saveError: "Unable to save configuration. Check your permissions and try again.", saved: "Configuration saved", save: "Save changes", saving: "Saving…", retry: "Retry",
    },
    activationErrors: {
      identity: "Check the Telegram conversation and acting-user identity, then reopen the app through Telegram and try again.",
      account: "Link your Telegram account to an active E-THEAP account, then try again.",
      access: "Ask the sale assignee or creator to grant you access.",
    },
    saleStatusLabel: "Sale status",
    saleCardSaleLabel: "Sale",
    saleCardPaymentLabel: "Payment",
    paymentStatusLabel: "Payment status",
    leadSalesTab: "Sales",
    leadTotalSummary: "Total leads",
    myLeads: "My Leads",
    myLeadTotal: "Total",
    myLeadFilters: "Filter my leads",
    leadUnassigned: "Unassigned",
    leadSummaryAssigneeScope: "Counts for the selected assignee only",
    myLeadToday: "Today",
    myLeadFollowUp: "Follow-ups",
    leadCardDate: "Date",
    leadAssigned: "Assigned",
    leadTodaySales: "Today’s Sales",
    leadTodaySalesHint: "Leads created today · Cambodia time",
    leadTodayFollowUps: "Today’s Follow-ups",
    leadTodayFollowUpsHint: "New or negotiating leads scheduled today · Cambodia time",
    leadCurrentUserFailed: "Unable to load your profile. Retry to load your assigned leads.",
    assigneeOptionsFailed: "Unable to load eligible assignees. Sale create or update permission is required.",
    leadSummaryUnavailable: "Summary counts are unavailable.",
    dateTimeExamplePrefix: "Ex:",
    navigationBreadcrumbs: "Navigation",
    assignmentLabels: { assignment: "Assignment", assigned: "Assigned" },
    activationFlow: { enterCode: "Enter your activation code to connect this group.", waiting: "Waiting for the Telegram group ID. Please open this app from your Telegram group.", checking: "Checking this Telegram group…", failed: "Unable to verify this Telegram group.", saleUnavailable: "This sale is unavailable or has been completed. Enter another activation code to continue.", code: "Activation code", activate: "Activate now" },
    leadList: { records: "leads", filters: "Filters", clearFilters: "Clear filters", clearSearch: "Clear search", compactView: "Card view", tableView: "Table view", pageSize: "Rows per page", loadMore: "Load more", openLead: "Open lead: {{name}}" },
    leadUI: {
      inlineUnavailable: "This lead changed. Reload the list before trying again.", inlineFailed: "Unable to update lead. Please try again.", saving: "Saving…",
      stageHint: "Choose the next stage to update this lead.", assignmentHint: "Search for a salesperson and set the next follow-up.",
      customer: "Customer & contact", contactHint: "Contact details are optional. A phone number is required to mark a lead as Won.",
      event: "Event & preferences", eventHint: "Choose an event type first. Other details can be added later.",
      followUp: "Priority & follow-up", followUpHint: "Keep the next conversation on your radar.",
      notes: "Notes & requirements", optionalHint: "Optional details to help your team pick up the conversation.",
      attachmentsHint: "JPG, PNG, WebP or PDF · Up to 30 files", createHint: "Start with the customer and event type. Fields marked * are required.",
      discardTitle: "Discard changes?", discardMessage: "Your unsaved changes will be lost.", discard: "Discard changes",
      validationSummary: "Check the highlighted fields before saving.", leadDetails: "Lead details", editLead: "Edit lead",
      notAdded: "Not added", notScheduled: "No follow-up scheduled", callCustomer: "Call customer", noNotes: "No notes added yet.", noAttachments: "No conversation attachments yet.",
      loadingOptions: "Loading event types and plans…", noActiveUsers: "No active users available for assignment.",
    },
    leadManagement: "Lead Management", marketingLeads: "All Leads", salesHandover: "Sales assignment", salesFollowUp: "Sales Follow-up", assign: "Assign",
    leadCreate: "Create lead", leadCreateEventSale: "Create Event Sale", leadOpenEventSale: "Open Event Sale", leadRetryConversion: "Retry conversion",
    leadConversionRetryInfo: "Conversion has started. This lead is read-only. Retrying reuses the original accepted conversion inputs; overrides cannot be changed.",
    leadConvertedReadOnly: "This lead has been converted and is read-only.", leadDeleteConfirm: "Delete this lead? This cannot be undone.",
    leadPermissionRequired: "This action requires Lead Management permission. Sign in again if your permissions have changed.", signInAgain: "Sign in again",
    leadSearch: "Search name, phone or Telegram", leadEmpty: "No leads match these filters.", leadFollowUpDue: "Follow-up due", leadNewest: "Newest first", leadFollowUpFirst: "Next follow-up",
    leadUploadAttachments: "Upload attachments", leadPlanUnavailable: "Plan unavailable — select an active plan", leadLinkedSale: "Linked event sale",
    leadHandoverDateInfo: "Leave blank to keep the current date. Use Edit to clear it.",
    leadStatus: { NEW: "New", NEGOTIATING: "Negotiating", WON: "Won", LOST: "Lost" },
    leadPriority: { VERY_HIGH: "Very High", HIGH: "High", MEDIUM: "Medium", LOW: "Low" },
    lead: { customerName: "Customer name", phone: "Phone", telegram: "Telegram", leadSource: "Lead source", eventTypeId: "Event type", interestedPlanId: "Interested plan", eventDate: "Event date", budget: "Budget", preferredLanguages: "Languages", templatePreference: "Template preference", customerRequirement: "Customer requirement", customerQuestions: "Customer questions", conversationReferences: "Conversation attachments", priority: "Priority", status: "Status", assignedSalesId: "Sales assignee", nextFollowUpAt: "Next follow-up", remark: "Remark" },
  },
  kh: {
    attachment: "ឯកសារភ្ជាប់",
    saleDepositAttachment: "ឯកសារកក់ប្រាក់",
    paymentAttachmentInvalid: "សូមជ្រើសរើសរូបភាព JPG, PNG, WEBP ឬបង្កាន់ដៃ PDF។",
    paymentAttachmentDenied: "មិនអាចបញ្ចូលឯកសារបានទេ។ គណនីរបស់អ្នកត្រូវការសិទ្ធិបញ្ចូលឯកសារ។",
    paymentAttachmentUploading: "កំពុងបញ្ចូលបង្កាន់ដៃ…",
    paymentAttachmentOpen: "បើកឯកសារ",
    paymentAttachmentEmpty: "បន្ថែមបង្កាន់ដៃបង់ប្រាក់",
    paymentAttachmentHint: "JPG, PNG, WEBP ឬ PDF · ស្រេចចិត្ត",
    paymentAttachmentReplace: "ប្ដូរបង្កាន់ដៃ",
    paymentAttachmentUpload: "បញ្ចូលបង្កាន់ដៃ",
    salePaymentEdit: "កែប្រែការបង់ប្រាក់", salePaymentAmount: "ចំនួនទឹកប្រាក់", salePaymentDate: "កាលបរិច្ឆេទបង់ប្រាក់", salePaymentReceivedBy: "អ្នកទទួលប្រាក់", salePaymentReceivedDate: "កាលបរិច្ឆេទទទួលប្រាក់", salePaymentInvalid: "សូមពិនិត្យចំនួនទឹកប្រាក់ និងកាលបរិច្ឆេទមុនពេលរក្សាទុក។",
    saleFinalPaymentAttachment: "ឯកសារទូទាត់ចុងក្រោយ",
    attachmentImagePreview: "មើលរូបភាព",
    mySales: "ការលក់របស់ខ្ញុំ",
    selectEventTypeBeforePlan: "សូមជ្រើសរើសប្រភេទកម្មវិធីជាមុន ដើម្បីត្រងតាមគម្រោង។",
    filterPlansLoadError: "មិនអាចផ្ទុកគម្រោងបានទេ។",
    eventDate: "កាលបរិច្ឆេទកម្មវិធី",
    saleEventDateRequired: "ត្រូវជ្រើសរើសកាលបរិច្ឆេទកម្មវិធី។",
    saleEventDateInvalid: "សូមជ្រើសរើសកាលបរិច្ឆេទ និងម៉ោងកម្មវិធីត្រឹមត្រូវ។",
    saleEventDateAscending: "កាលបរិច្ឆេទកម្មវិធី៖ មុនទៅក្រោយ",
    saleEventDateDescending: "កាលបរិច្ឆេទកម្មវិធី៖ ក្រោយទៅមុន",
    timeHour: "ម៉ោង (២៤ ម៉ោង)",
    timeMinute: "នាទី",
    dateTimeInputInvalid: "បញ្ចូលកាលបរិច្ឆេទ/ម៉ោងត្រឹមត្រូវតាម {{format}} (ម៉ោង ២៤)។",
    audioRecording: { hint: "រូបភាព PDF ឬសំឡេងដែលបានថត · រហូតដល់ 30 ឯកសារ", start: "ថតសំឡេង", starting: "កំពុងបើកមីក្រូហ្វូន…", stop: "បញ្ឈប់ និងភ្ជាប់", recording: "កំពុងថត… បញ្ឈប់ដើម្បីបញ្ចូល និងភ្ជាប់សំឡេង។", unsupported: "កម្មវិធីរុករកនេះមិនគាំទ្រការថតសំឡេងទេ។", permission: "មិនអាចបើកមីក្រូហ្វូនបាន។ សូមអនុញ្ញាតការប្រើមីក្រូហ្វូន ហើយព្យាយាមម្តងទៀត។", failed: "មិនអាចភ្ជាប់សំឡេងបាន។ សូមព្យាយាមម្តងទៀត។", invalidAttachment: "ជ្រើសរើសរូបភាព PDF ឬសំឡេងដែលបានថត រហូតដល់ ៣០ ឯកសារ។", preview: "សំឡេងការសន្ទនា", retry: "ព្យាយាមបញ្ចូលសំឡេងម្តងទៀត" },
    upcoming: { dueSales: "ការលក់ជិតដល់កំណត់", followUpSales: "ការលក់តាមដាន", title: "ពេលខាងមុខ", sales: "ការលក់ជិតដល់កំណត់ ({{days}} ថ្ងៃ)", leads: "កម្មវិធីពេលខាងមុខ ({{days}} ថ្ងៃ)", loading: "កំពុងផ្ទុកការកំណត់តម្រង", error: "មិនអាចផ្ទុកការកំណត់តម្រងពេលខាងមុខបាន។", precedence: "កាលបរិច្ឆេទដល់កំណត់ ឬតម្រងថ្ងៃនេះមានអាទិភាពលើតម្រងពេលខាងមុខ។" },
    globalConfig: {
      title: "ការកំណត់", upcomingFilters: "តម្រងពេលខាងមុខ",
      saleDueWithinDays: "ការលក់ដល់កំណត់ក្នុង (ថ្ងៃ)", eventWithinDays: "កម្មវិធីក្នុង (ថ្ងៃ)",
      invalid: "បញ្ចូលចំនួនគត់៖ {{limit}}", notFound: "រកមិនឃើញការកំណត់តម្រងពេលខាងមុខ។ សូមទាក់ទងអ្នកគ្រប់គ្រង រួចព្យាយាមម្តងទៀត។",
      readOnly: "មានតែអ្នកគ្រប់គ្រងអាចកែការកំណត់នេះ។", loading: "កំពុងផ្ទុកការកំណត់", loadError: "មិនអាចផ្ទុកការកំណត់បាន។ សូមពិនិត្យសិទ្ធិចូលប្រើ។",
      saveError: "មិនអាចរក្សាទុកបាន។ សូមពិនិត្យសិទ្ធិ ហើយព្យាយាមម្តងទៀត។", saved: "បានរក្សាទុកការកំណត់", save: "រក្សាទុកការផ្លាស់ប្តូរ", saving: "កំពុងរក្សាទុក…", retry: "ព្យាយាមម្តងទៀត",
    },
    activationErrors: {
      identity: "សូមពិនិត្យអត្តសញ្ញាណការសន្ទនា និងអ្នកប្រើ Telegram រួចបើកកម្មវិធីឡើងវិញតាម Telegram ហើយព្យាយាមម្តងទៀត។",
      account: "សូមភ្ជាប់គណនី Telegram របស់អ្នកទៅគណនី E-THEAP ដែលកំពុងដំណើរការ រួចព្យាយាមម្តងទៀត។",
      access: "សូមស្នើអ្នកទទួលបន្ទុក ឬអ្នកបង្កើតការលក់ឱ្យផ្តល់សិទ្ធិចូលប្រើ។",
    },
    saleStatusLabel: "ស្ថានភាពការលក់",
    saleCardSaleLabel: "ការលក់",
    saleCardPaymentLabel: "ការទូទាត់",
    paymentStatusLabel: "ស្ថានភាពការទូទាត់",
    leadSalesTab: "ផ្នែកលក់",
    leadTotalSummary: "អតិថិជនសក្តានុពលសរុប",
    myLeads: "អតិថិជនសក្តានុពលរបស់ខ្ញុំ",
    myLeadTotal: "សរុប",
    myLeadFilters: "ត្រងអតិថិជនសក្តានុពលរបស់ខ្ញុំ",
    leadUnassigned: "មិនទាន់មានអ្នកទទួលខុសត្រូវ",
    leadSummaryAssigneeScope: "ចំនួនសម្រាប់អ្នកទទួលខុសត្រូវដែលបានជ្រើសរើសប៉ុណ្ណោះ",
    myLeadToday: "ថ្ងៃនេះ",
    myLeadFollowUp: "តាមដាន",
    leadCardDate: "កាលបរិច្ឆេទ",
    leadAssigned: "បានកំណត់អ្នកទទួលបន្ទុក",
    leadTodaySales: "ការលក់ថ្ងៃនេះ",
    leadTodaySalesHint: "អតិថិជនសក្តានុពលដែលបានបង្កើតថ្ងៃនេះ · ម៉ោងកម្ពុជា",
    leadTodayFollowUps: "ការតាមដានថ្ងៃនេះ",
    leadTodayFollowUpsHint: "អតិថិជនថ្មី ឬកំពុងចរចាដែលត្រូវតាមដានថ្ងៃនេះ · ម៉ោងកម្ពុជា",
    leadCurrentUserFailed: "មិនអាចផ្ទុកប្រវត្តិរូបរបស់អ្នកបានទេ។ សូមព្យាយាមម្តងទៀត។",
    assigneeOptionsFailed: "មិនអាចផ្ទុកអ្នកទទួលខុសត្រូវបានទេ។ ត្រូវការសិទ្ធិបង្កើត ឬកែសម្រួលការលក់។",
    leadSummaryUnavailable: "មិនមានចំនួនសង្ខេប។",
    dateTimeExamplePrefix: "ឧ៖",
    navigationBreadcrumbs: "ការរុករក",
    assignmentLabels: { assignment: "ការចាត់តាំង", assigned: "បានចាត់តាំង" },
    activationFlow: { enterCode: "បញ្ចូលលេខកូដដំណើរការដើម្បីភ្ជាប់ក្រុមនេះ។", waiting: "កំពុងរង់ចាំលេខសម្គាល់ក្រុម Telegram។ សូមបើកកម្មវិធីពីក្រុម Telegram របស់អ្នក។", checking: "កំពុងពិនិត្យក្រុម Telegram នេះ…", failed: "មិនអាចផ្ទៀងផ្ទាត់ក្រុម Telegram នេះបានទេ។", saleUnavailable: "ការលក់នេះមិនមាន ឬបានបញ្ចប់ហើយ។ សូមបញ្ចូលលេខកូដផ្សេងដើម្បីបន្ត។", code: "លេខកូដដំណើរការ", activate: "ដំណើរការឥឡូវនេះ" },
    leadList: { records: "អតិថិជនសក្តានុពល", filters: "តម្រង", clearFilters: "សម្អាតតម្រង", clearSearch: "សម្អាតការស្វែងរក", compactView: "ទិដ្ឋភាពកាត", tableView: "ទិដ្ឋភាពតារាង", pageSize: "ជួរដេកក្នុងមួយទំព័រ", loadMore: "ផ្ទុកបន្ថែម", openLead: "បើកអតិថិជនសក្តានុពល៖ {{name}}" },
    leadUI: {
      stageHint: "ជ្រើសរើសដំណាក់កាលបន្ទាប់ ដើម្បីធ្វើបច្ចុប្បន្នភាពអតិថិជនសក្តានុពលនេះ។", assignmentHint: "ស្វែងរកអ្នកលក់ និងកំណត់ពេលតាមដានបន្ទាប់។",
      inlineUnavailable: "អតិថិជនសក្តានុពលនេះបានផ្លាស់ប្តូរ។ សូមផ្ទុកបញ្ជីឡើងវិញមុនពេលព្យាយាមម្តងទៀត។", inlineFailed: "មិនអាចធ្វើបច្ចុប្បន្នភាពបានទេ។ សូមព្យាយាមម្តងទៀត។", saving: "កំពុងរក្សាទុក…",
      customer: "អតិថិជន និងទំនាក់ទំនង", contactHint: "ព័ត៌មានទំនាក់ទំនងជាជម្រើស។ ត្រូវមានលេខទូរស័ព្ទដើម្បីកំណត់ថាឈ្នះ។",
      event: "កម្មវិធី និងចំណូលចិត្ត", eventHint: "ជ្រើសរើសប្រភេទកម្មវិធីជាមុន។ ព័ត៌មានផ្សេងទៀតអាចបន្ថែមនៅពេលក្រោយ។",
      followUp: "អាទិភាព និងការតាមដាន", followUpHint: "កំណត់ពេលសម្រាប់ការទាក់ទងបន្ទាប់។",
      notes: "កំណត់ចំណាំ និងតម្រូវការ", optionalHint: "ព័ត៌មានបន្ថែមសម្រាប់ជួយក្រុមការលក់បន្តការសន្ទនា។",
      attachmentsHint: "JPG, PNG, WebP ឬ PDF · រហូតដល់ 30 ឯកសារ", createHint: "ចាប់ផ្តើមជាមួយអតិថិជន និងប្រភេទកម្មវិធី។ វាលដែលមាន * គឺចាំបាច់។",
      discardTitle: "បោះបង់ការកែប្រែ?", discardMessage: "ការកែប្រែដែលមិនទាន់រក្សាទុកនឹងត្រូវបាត់បង់។", discard: "បោះបង់ការកែប្រែ",
      validationSummary: "សូមពិនិត្យវាលដែលបានបន្លិចមុនពេលរក្សាទុក។", leadDetails: "ព័ត៌មានអតិថិជនសក្តានុពល", editLead: "កែប្រែអតិថិជនសក្តានុពល",
      notAdded: "មិនទាន់បញ្ចូល", notScheduled: "មិនទាន់កំណត់ពេលតាមដាន", callCustomer: "ហៅអតិថិជន", noNotes: "មិនទាន់មានកំណត់ចំណាំ។", noAttachments: "មិនទាន់មានឯកសារសន្ទនា។",
      loadingOptions: "កំពុងផ្ទុកប្រភេទកម្មវិធី និងគម្រោង…", noActiveUsers: "មិនមានអ្នកប្រើប្រាស់សកម្មសម្រាប់ចាត់តាំងទេ។",
    },
    leadManagement: "ការគ្រប់គ្រងអតិថិជនសក្តានុពល", marketingLeads: "អតិថិជនពីទីផ្សារ", salesHandover: "កំណត់អ្នកទទួលបន្ទុកលក់", salesFollowUp: "ការតាមដានការលក់", assign: "ចាត់តាំង",
    leadCreate: "បង្កើតអតិថិជនសក្តានុពល", leadCreateEventSale: "បង្កើតការលក់កម្មវិធី", leadOpenEventSale: "បើកការលក់កម្មវិធី", leadRetryConversion: "ព្យាយាមបង្កើតការលក់ម្តងទៀត",
    leadConversionRetryInfo: "ការបង្កើតការលក់បានចាប់ផ្តើម។ មិនអាចកែប្រែបានទេ។ ការព្យាយាមម្តងទៀតនឹងប្រើព័ត៌មានដើមដែលបានទទួលយក។",
    leadConvertedReadOnly: "បានបង្កើតការលក់សម្រាប់អតិថិជននេះរួចហើយ។ មិនអាចកែប្រែបានទេ។", leadDeleteConfirm: "លុបអតិថិជនសក្តានុពលនេះ? មិនអាចយកមកវិញបានទេ។",
    leadPermissionRequired: "សកម្មភាពនេះត្រូវការសិទ្ធិគ្រប់គ្រងអតិថិជនសក្តានុពល។ សូមចូលម្តងទៀត ប្រសិនបើសិទ្ធិបានផ្លាស់ប្តូរ។", signInAgain: "ចូលម្តងទៀត",
    leadSearch: "ស្វែងរកឈ្មោះ ទូរស័ព្ទ ឬ Telegram", leadEmpty: "មិនមានអតិថិជនត្រូវនឹងតម្រងនេះទេ។", leadFollowUpDue: "ដល់ពេលតាមដាន", leadNewest: "ថ្មីបំផុតមុន", leadFollowUpFirst: "ការតាមដានបន្ទាប់",
    leadUploadAttachments: "បង្ហោះឯកសារភ្ជាប់", leadPlanUnavailable: "គម្រោងមិនអាចប្រើបាន — សូមជ្រើសគម្រោងសកម្ម", leadLinkedSale: "ការលក់ដែលបានភ្ជាប់",
    leadHandoverDateInfo: "ទុកទទេដើម្បីរក្សាកាលបរិច្ឆេទបច្ចុប្បន្ន។ ប្រើការកែប្រែដើម្បីលុបវា។",
    leadStatus: { NEW: "ថ្មី", NEGOTIATING: "កំពុងចរចា", WON: "បានជោគជ័យ", LOST: "បាត់បង់" },
    leadPriority: { VERY_HIGH: "ខ្ពស់បំផុត", HIGH: "ខ្ពស់", MEDIUM: "មធ្យម", LOW: "ទាប" },
    lead: { customerName: "ឈ្មោះអតិថិជន", phone: "ទូរស័ព្ទ", telegram: "Telegram", leadSource: "ប្រភពអតិថិជន", eventTypeId: "ប្រភេទកម្មវិធី", interestedPlanId: "គម្រោងដែលចាប់អារម្មណ៍", eventDate: "កាលបរិច្ឆេទកម្មវិធី", budget: "ថវិកា", preferredLanguages: "ភាសាដែលចង់បាន", templatePreference: "គំរូដែលចង់បាន", customerRequirement: "តម្រូវការអតិថិជន", customerQuestions: "សំណួរអតិថិជន", conversationReferences: "ឯកសារសន្ទនា", priority: "អាទិភាព", status: "ស្ថានភាព", assignedSalesId: "អ្នកទទួលបន្ទុកលក់", nextFollowUpAt: "ការតាមដានបន្ទាប់", remark: "កំណត់ចំណាំ" },
  },
  ch: {
    attachment: "附件",
    saleDepositAttachment: "定金附件",
    paymentAttachmentInvalid: "请选择 JPG、PNG、WEBP 图片或 PDF 收据。",
    paymentAttachmentDenied: "上传被拒绝。您的账号需要文件上传权限。",
    paymentAttachmentUploading: "正在上传收据…",
    paymentAttachmentOpen: "打开附件",
    paymentAttachmentEmpty: "添加付款收据",
    paymentAttachmentHint: "JPG、PNG、WEBP 或 PDF · 可选",
    paymentAttachmentReplace: "替换收据",
    paymentAttachmentUpload: "上传收据",
    salePaymentEdit: "编辑付款", salePaymentAmount: "金额", salePaymentDate: "付款日期", salePaymentReceivedBy: "收款人", salePaymentReceivedDate: "收款日期", salePaymentInvalid: "保存前请检查付款金额和日期。",
    saleFinalPaymentAttachment: "尾款附件",
    attachmentImagePreview: "预览图片",
    mySales: "我的销售",
    selectEventTypeBeforePlan: "请先选择活动类型，再按套餐筛选。",
    filterPlansLoadError: "无法加载套餐。",
    eventDate: "活动日期",
    saleEventDateRequired: "请选择活动日期。",
    saleEventDateInvalid: "请选择有效的活动日期和时间。",
    saleEventDateAscending: "活动日期：从早到晚",
    saleEventDateDescending: "活动日期：从晚到早",
    timeHour: "小时（24小时制）",
    timeMinute: "分钟",
    dateTimeInputInvalid: "请输入有效日期/时间，格式为 {{format}}（24 小时制）。",
    audioRecording: { hint: "图片、PDF 或录音 · 最多 30 个文件", start: "录制音频", starting: "正在打开麦克风…", stop: "停止并添加附件", recording: "正在录音… 停止后自动上传并添加附件。", unsupported: "当前浏览器不支持录音。", permission: "无法打开麦克风，请允许麦克风访问后重试。", failed: "无法添加录音，请重试。", invalidAttachment: "最多选择 30 个图片、PDF 或录音附件。", preview: "对话录音", retry: "重试上传录音" },
    upcoming: { dueSales: "到期销售", followUpSales: "跟进销售", title: "即将到期", sales: "即将到期的销售（{{days}} 天）", leads: "近期活动（{{days}} 天）", loading: "正在加载筛选设置", error: "无法加载近期筛选设置。", precedence: "指定到期日期或今天筛选优先于即将到期筛选。" },
    globalConfig: {
      title: "设置", upcomingFilters: "即将到期筛选",
      saleDueWithinDays: "销售到期天数", eventWithinDays: "活动临近天数",
      invalid: "请输入整数：{{limit}}", notFound: "未找到即将到期筛选配置，请联系管理员初始化配置后重试。",
      readOnly: "仅管理员可以编辑这些设置。", loading: "正在加载配置", loadError: "无法加载配置，请检查访问权限。",
      saveError: "无法保存配置，请检查权限并重试。", saved: "配置已保存", save: "保存更改", saving: "正在保存…", retry: "重试",
    },
    activationErrors: {
      identity: "请检查 Telegram 会话和操作用户身份，然后通过 Telegram 重新打开应用并重试。",
      account: "请将您的 Telegram 账号关联到有效的 E-THEAP 账号，然后重试。",
      access: "请联系销售负责人或创建者授予访问权限。",
    },
    saleStatusLabel: "销售状态",
    saleCardSaleLabel: "销售",
    saleCardPaymentLabel: "付款",
    paymentStatusLabel: "付款状态",
    leadSalesTab: "销售",
    leadTotalSummary: "线索总数",
    myLeads: "我的线索",
    myLeadTotal: "总计",
    myLeadFilters: "筛选我的线索",
    leadUnassigned: "未分配",
    leadSummaryAssigneeScope: "仅统计所选负责人的线索",
    myLeadToday: "今日",
    myLeadFollowUp: "跟进",
    leadCardDate: "日期",
    leadAssigned: "已分配",
    leadTodaySales: "今日销售",
    leadTodaySalesHint: "今日创建的线索 · 柬埔寨时间",
    leadTodayFollowUps: "今日跟进",
    leadTodayFollowUpsHint: "安排在今天跟进的新线索或洽谈中线索 · 柬埔寨时间",
    leadCurrentUserFailed: "无法加载您的个人资料。请重试以加载分配给您的线索。",
    assigneeOptionsFailed: "无法加载可分配用户。需要销售创建或更新权限。",
    leadSummaryUnavailable: "汇总计数不可用。",
    dateTimeExamplePrefix: "例如：",
    navigationBreadcrumbs: "导航",
    assignmentLabels: { assignment: "分配", assigned: "已分配" },
    activationFlow: { enterCode: "输入激活码以绑定此群组。", waiting: "正在等待 Telegram 群组 ID。请从您的 Telegram 群组打开此应用。", checking: "正在验证此 Telegram 群组…", failed: "无法验证此 Telegram 群组。", saleUnavailable: "此销售不可用或已完成。请输入其他激活码以继续。", code: "激活码", activate: "立即激活" },
    leadList: { records: "条线索", filters: "筛选", clearFilters: "清除筛选", clearSearch: "清除搜索", compactView: "卡片视图", tableView: "表格视图", pageSize: "每页行数", loadMore: "加载更多", openLead: "打开线索：{{name}}" },
    leadUI: {
      stageHint: "选择下一阶段以更新此线索。", assignmentHint: "搜索销售人员并安排下次跟进。",
      inlineUnavailable: "此线索已更改，请刷新列表后重试。", inlineFailed: "无法更新线索，请重试。", saving: "正在保存…",
      customer: "客户与联系方式", contactHint: "联系方式为选填。将线索标记为赢单时必须填写电话号码。",
      event: "活动与偏好", eventHint: "先选择活动类型，其他信息可以稍后补充。",
      followUp: "优先级与跟进", followUpHint: "安排好下一次客户沟通。",
      notes: "备注与需求", optionalHint: "补充信息，方便团队继续与客户沟通。",
      attachmentsHint: "JPG、PNG、WebP 或 PDF · 最多 30 个文件", createHint: "先填写客户和活动类型。标有 * 的字段为必填项。",
      discardTitle: "放弃修改？", discardMessage: "未保存的修改将丢失。", discard: "放弃修改",
      validationSummary: "请检查标出的字段后再保存。", leadDetails: "线索详情", editLead: "编辑线索",
      notAdded: "未填写", notScheduled: "尚未安排跟进", callCustomer: "致电客户", noNotes: "暂无备注。", noAttachments: "暂无对话附件。",
      loadingOptions: "正在加载活动类型和套餐…", noActiveUsers: "没有可分配的活跃用户。",
    },
    leadManagement: "潜在客户管理", marketingLeads: "营销线索", salesHandover: "分配销售负责人", salesFollowUp: "销售跟进", assign: "分配",
    leadCreate: "创建线索", leadCreateEventSale: "创建活动销售", leadOpenEventSale: "打开活动销售", leadRetryConversion: "重试转换",
    leadConversionRetryInfo: "转换已开始，此线索为只读。重试将使用首次接受的转换信息，无法修改覆盖选项。",
    leadConvertedReadOnly: "此线索已转换，为只读状态。", leadDeleteConfirm: "删除此线索？此操作无法撤销。",
    leadPermissionRequired: "此操作需要线索管理权限。如果权限已更改，请重新登录。", signInAgain: "重新登录",
    leadSearch: "搜索姓名、电话或 Telegram", leadEmpty: "没有符合筛选条件的线索。", leadFollowUpDue: "跟进已到期", leadNewest: "最新优先", leadFollowUpFirst: "下次跟进",
    leadUploadAttachments: "上传附件", leadPlanUnavailable: "套餐不可用，请选择有效套餐", leadLinkedSale: "关联的活动销售",
    leadHandoverDateInfo: "留空保留当前日期。使用编辑清除日期。",
    leadStatus: { NEW: "新线索", NEGOTIATING: "洽谈中", WON: "已成交", LOST: "已流失" },
    leadPriority: { VERY_HIGH: "非常高", HIGH: "高", MEDIUM: "中", LOW: "低" },
    lead: { customerName: "客户姓名", phone: "电话", telegram: "Telegram", leadSource: "线索来源", eventTypeId: "活动类型", interestedPlanId: "意向套餐", eventDate: "活动日期", budget: "预算", preferredLanguages: "首选语言", templatePreference: "模板偏好", customerRequirement: "客户需求", customerQuestions: "客户问题", conversationReferences: "对话附件", priority: "优先级", status: "状态", assignedSalesId: "销售负责人", nextFollowUpAt: "下次跟进", remark: "备注" },
  },
};

const resources = {
  en: {
    translation: {
      ...leadTranslations.en,
      telegramActivation: "Telegram activation",
      telegramActivationUnavailable: "Activation unavailable",
      telegramConnected: "Telegram connected",
      telegramNotConnected: "Telegram not connected",
      revealActivationCode: "Reveal code",
      hideActivationCode: "Hide code",
      copyActivationCode: "Copy code",
      activationCodeLabel: "Activation Code",
      activationCodeCopied: "Activation code copied",
      activationCodeCopyFailed: "Unable to copy activation code. Please try again.",
      info: "Info",
      scan: "Scan",
      add: "Add",
      dashboard: "Dashboard",
      manageUser: "Manage User",
      userProfile: "User Profile",
      manageGuest: "Manage Guest",
      rsvp: "RSVP",
      guestContribution: "Guest Contribution",
      report: "Report",
      scanQRCode: "Scan QR Code",
      close: "Close",
      noCamera: "No camera available",
      cameraPermissionDenied: "Camera permission denied",
      addGuest: "Add Guest",
      eventManagement: "Event Management",
      guestActivities: "Guest Activity & RSVPs",
      preferencesAndSupport: "Preferences & Support",
      session: "Account",
      appearance: "Appearance",
      themeMode: "Theme Mode",
      darkMode: "Dark Mode",
      lightMode: "Light Mode",
      // Manage Guest Page
      total: "Total",
      invited: "Invited",
      notInvited: "Not Invited",
      all: "All",
      guestList: "Guest List",
      searchGuests: "Search guests...",
      select: "Select",
      selectAll: "Select All",
      done: "Done",
      noGuestsFound: "No guests found",
      changeStatus: "Change Status",
      actions: "Actions",
      printQRCode: "Print QR Code",
      delete: "Delete",
      edit: "Edit",
      wishes: "Wishes",
      wish: "Wish",
      cancel: "Cancel",
      confirm: "Confirm",
      save: "Save",
      tag: "Tag",
      guestName: "Guest Name",
      guestNames: "Guest Names",
      guestNamesPlaceholder: "Enter guest names (one per line)",
      guestNamesHelper: "Enter each guest name on a new line",
      editGuest: "Edit Guest",
      deleteGuest: "Delete Guest",
      deleteGuests: "Delete Guests",
      deleteGuestConfirm: "Are you sure you want to delete {{name}}?",
      deleteGuestsConfirm: "Are you sure you want to delete {{count}} guests?",
      guestsCreated: "Guests created successfully",
      guestUpdated: "Guest updated successfully",
      guestDeleted: "Guest deleted successfully",
      guestsDeleted: "{{count}} guests deleted successfully",
      guestsStatusUpdated: "{{count}} guests status updated",
      fetchGuestsError: "Failed to fetch guests",
      createGuestsError: "Failed to create guests",
      updateGuestError: "Failed to update guest",
      deleteGuestError: "Failed to delete guest",
      deleteGuestsError: "Failed to delete guests",
      updateGuestsStatusError: "Failed to update guests status",
      printQRCodeFeature: "Print QR Code feature coming soon",
      // Search & Filter
      allTags: "All Tags",
      searchByNameOrTag: "Search by name or tag...",
      searchByNameTagOrNote: "Search by name, tag, or note...",
      // Print QR Code
      downloadQRCode: "Download QR Code",
      download: "Download",
      downloading: "Downloading...",
      invitationLink: "Invitation Link",
      shareVia: "Share via",
      invitationFor: "Invitation for",
      guestNotFound: "Guest not found",
      // Wishes
      wishesFrom: "Wishes From",
      attend: "Attend",
      attendingGuests: "Attending Guests",
      yes: "Yes",
      no: "No",
      show: "Show",
      hide: "Hide",
      noWishesFound: "No wishes found",
      noWishesDescription: "Try adjusting your search or filter criteria",
      noGuestsDescription: "Try adjusting your search or filter criteria",
      wishVisibilityUpdated: "Wish visibility updated",
      wishVisibilityError: "Failed to update wish visibility",
      createdAt: "Created At",
      updatedAt: "Updated At",
      responseAt: "Response At",
      // Bulk Print
      printGuestList: "Print Guest List",
      settings: "Settings",
      guestNameSize: "Guest Name Size",
      qrCodeSize: "QR Code Size",
      fontSize: "Font Size",
      width: "Width",
      height: "Height",
      print: "Print",
      totalGuests: "Total Guests",
      qrCodes: "QR Codes",
      noGuestsSelected: "No guests selected",
      backToGuestList: "Back to Guest List",
      small: "Small",
      medium: "Medium",
      large: "Large",
      custom: "Custom",
      // Add Guest Page
      enterGuestName: "Enter guest name",
      selectOrCreateTag: "Select or create tag",
      // Wishes List
      mayBe: "May Be",
      notAttend: "Not Attend",
      notResponse: "Not Response",
      usd: "USD",
      khr: "KHR",
      cash: "Cash",
      qrCode: "QR Code",
      QRCode: "QR កូដ",
      // Dashboard
      totalGuest: "Total Guest",
      totalWishes: "Total Wishes",
      notInvitedGuest: "Not Invited Guest",
      totalGuestStatus: "Total Guest Status",
      totalGuestContribution: "Total Guest Contribution",
      grandTotal: "Grand Total",
      attendGuest: "Attend Guest",
      notAttendGuest: "Not Attend Guest",
      pendingResponse: "Pending Response",
      walkInGuest: "Walk-in Guest",
      usdGuest: "USD Guest",
      khrGuest: "KHR Guest",
      // Report
      reportGuest: "Report Guest",
      reportRSVP: "Report RSVP",
      reportContribution: "Report Contribution",
      addContribution: "Add Contribution",
      editContribution: "Edit Contribution",
      manageTags: "Manage Tags",
      reorderTags: "Reorder Tags",
      reorderTagsDescription: "Drag the handle to reorder tags",
      tagsReorderedSuccessfully: "Tags reordered successfully",
      failedToReorderTags: "Failed to reorder tags",
      moveUp: "Move Up",
      moveDown: "Move Down",
      addTag: "Add Tag",
      editTag: "Edit Tag",
      tagName: "Tag Name",
      enterTagName: "Enter tag name",
      noTagsYet: "No tags yet. Create your first tag!",
      deleteContributionConfirm:
        "Are you sure you want to delete contribution from {{name}}?",
      contributionDeleted: "Contribution deleted",
      contributionDeletedSuccess:
        "The contribution has been deleted successfully",
      deleteFailed: "Delete failed",
      deleteFailedDescription:
        "Failed to delete contribution. Please try again.",
      noContributionsFound: "No contributions found",
      noContributionsDescription:
        "Try adjusting your search or filter criteria",
      amountMustBePositive: "Amount must be greater than 0",
      currencyRequired: "Currency is required",
      selectCurrency: "Select Currency",
      noContributions: "No contributions yet",
      create: "Create",
      update: "Update",
      selectLanguage: "Select Language",
      back: "Back",
      quickSetup: "Quick setup",
      salePending: "Pending",
      saleView: "View",
      saleDeposit: "Deposit",
      saleFinalPayment: "Final payment",
      saleMissingCount_one: "{{count}} missing value",
      saleMissingCount_other: "{{count}} missing values",
      saleFieldsComplete: "All fields filled",
      saleCompletionCounts: "✓ {{completed}} completed · ○ {{missing}} missing",
      saleFilledValue: "Filled",
      saleMissingValue: "Missing",
      saleChecklistLoading: "Loading checklist…",
      saleChecklistUnavailable: "No fields available to check",
      saleDetailsFailed: "Could not load sale details.",
      saleDetails: "Sale details",
      salePaymentSummary: "Payment summary",
      saleRetry: "Retry",
      saleInProgress: "In Progress",
      saleDone: "Done",
      startSale: "Start work",
      completeSale: "Mark as done",
      saleStatusUpdated: "Sale status updated",
      saleStatusUpdateFailed: "Could not update sale status. Please try again.",
      saleUnassigned: "Unassigned",
      saleUnknownUser: "Unknown user",
      saleNoPayment: "Unpaid",
      salePartialPayment: "Partially paid",
      saleCompletePayment: "Paid",
      loadingPlans: "Loading plans…",
      loadPlansFailed: "Could not load plans. Please select the event type again.",
      noEventPlans: "No plans are configured for this event type.",
      general: "General",
      eventDetail: "Event Detail",
      setupDescription: "Choose your languages and event, then fill in the details.",
      chooseEventFirst: "Choose an event type to get started.",
      noEventFields: "No extra details are needed for this event.",
      plan: "Plan",
      assignee: "Assignee",
      you: "You",
      remark: "Remark",
      createSale: "Create Sale",
      editSale: "Edit Sale",
      summaryInformation: "Summary Information",
      permissionsLoading: "Loading permissions…",
      permissionsUnavailable: "Permissions are unavailable. Access is denied until your session can be verified.",
      permissionPageDenied: "You do not have permission to view this page.",
      permissionReadOnly: "Read-only: your account cannot edit this record.",
      permissionAssignees: "Loading assignee options requires permission to create or update sales.",
      imagePreviewFailed: "Unable to load image.",
      imagePreviewLoading: "Loading image…",
      uploadImageConfirm: "Upload",
      openDatePicker: "Open date picker",
      openTimePicker: "Open time picker",
      pasteImage: "Paste image",
      imageClipboardEmpty: "No image found. Copy the image itself, then try again.",
      imageClipboardUnavailable: "Clipboard access is unavailable or denied. Paste into the field directly, or save the image and upload it.",
      imagePasteHint: "Copy an image, then focus this field and paste to upload.",
      customListAddItem: "Add item",
      customListEmpty: "No items yet. Use the button below to add an item.",
      summaryInformationSaved: "Summary information saved successfully.",
      summaryInformationSaveFailed: "Failed to save summary information. Please try again.",
      continueWithTelegram: "Continue with Telegram",
      telegramConnecting: "Connecting with Telegram...",
      telegramOpenApp: "Please open Sale Support in Telegram.",
      telegramLoginFailed: "Unable to log in. Please try again.",
      unauthorizedAccess: "Unauthorized Access",
      telegramUnauthorizedMsg: "Authentication error: Invalid Telegram credentials",
      telegramUnauthorizedHint: "This Telegram account is not registered, inactive, or unlinked. Please share your Telegram ID with the administrator to get access.",
      tryAgain: "Try Again",
      closeApp: "Close App",
      title: "Title",
      dueDate: "Due Date",
      saleManagement: "Sale Management",
      allSales: "All Sales",
      allStatus: "All Status",
      newSale: "New Sale",
      eventType: "Event Type",
      language: "Language",
      template: "Template",
      detail: "Detail",
      copied: "Copied",
      statusUpdateError: "Failed to update status",
      quickSelect: "Quick Select",
      tagNames: "Multiple Tags",
      other: "Other",
      // User Profile
      profileNotFound: "Profile not found",
      fullName: "Full Name",
      email: "Email",
      phone: "Phone",
      role: "Role",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      memberSince: "Member Since",
      lastUpdated: "Last Updated",
      // Import/Export
      downloadTemplate: "Download Template",
      uploadGuests: "Upload Guests",
      exportGuests: "Export Guests",
      templateDownloaded: "Template downloaded successfully",
      downloadTemplateFailed: "Failed to download template",
      guestsUploadedSuccessfully: "Guests uploaded successfully",
      uploadGuestsFailed: "Failed to upload guests",
      guestsExportedSuccessfully: "Guests exported successfully",
      exportGuestsFailed: "Failed to export guests",
      export: "Export",
      exporting: "Exporting...",
      logout: "Logout",
      filter: "Filter",
      filterByTags: "Filter By Tags",
      share: "Share",
      visibility: "Visibility",
      setting: "Setting",
      currency: "Currency",
      exchangeRate: "Exchange Rate",
      addCurrency: "Add Currency",
      editCurrency: "Edit Currency",
      currencyCode: "Currency Code",
      currencyName: "Currency Name",
      noCurrenciesFound: "No currencies found",
      currencyCreatedSuccessfully: "Currency created successfully",
      currencyUpdatedSuccessfully: "Currency updated successfully",
      currencyDeletedSuccessfully: "Currency deleted successfully",
      failedToLoadCurrencies: "Failed to load currencies",
      addExchangeRate: "Add Exchange Rate",
      editExchangeRate: "Edit Exchange Rate",
      rate: "Rate",
      noExchangeRatesFound: "No exchange rates found",
      confirmDeleteWithName: "Are you sure you want to delete {{name}}?",
      exchangeRateCreatedSuccessfully: "Exchange rate created successfully",
      exchangeRateUpdatedSuccessfully: "Exchange rate updated successfully",
      exchangeRateDeletedSuccessfully: "Exchange rate deleted successfully",
      failedToLoadExchangeRates: "Failed to load exchange rates",
      pleaseCompleteAllFields: "Please complete all fields",
      operationFailed: "Operation failed",
      confirmDelete: "Are you sure you want to delete this?",
      // Guest Detail
      contributionNotFound: "Contribution not found",
      guestDetail: "Guest Detail",
      userName: "User Name",
      invitedAt: "Invited At",
      rsvpSummary: "RSVP Summary",
      respondedAt: "Responded At",
      guestWishes: "Guest Wishes",
      contributionSummary: "Contribution Summary",
      paymentAt: "Payment At",
      paymentType: "Payment Type",
      currencyType: "Currency Type",
      amount: "Amount",
      guestNote: "Guest Note",
      walkIn: "Walk In",
      enterName: "Enter Name",
      enterNote: "Enter Note",
      // ManageTags
      validationError: "Validation Error",
      tagNameRequired: "Tag name is required",
      duplicateTag: "Duplicate Tag",
      tagAlreadyExists: "This tag already exists",
      tagUpdatedSuccessfully: "Tag updated successfully",
      tagCreatedSuccessfully: "Tag created successfully",
      tagDeleted: "Tag Deleted",
      tagDeletedSuccess: 'Tag "{{name}}" has been deleted successfully',
      tagDeleteFailed: "Delete Failed",
      tagDeleteFailedDescription: "Failed to delete tag. Please try again.",
      failedToUpdateTag: "Failed to update tag. Please try again.",
      failedToCreateTag: "Failed to create tag. Please try again.",
      deleteTagConfirm: 'Are you sure you want to delete tag "{{name}}"?',
      // Contribution Form
      failedToLoadGuestFromQR: "Failed to load guest from QR code",
      pleaseRetryAgain: "Please try again",
      contributionUpdatedSuccessfully: "Updated successfully!",
      contributionSavedSuccessfully: "Saved successfully!",
      failedToUpdateContribution:
        "Failed to update contribution. Please try again.",
      failedToSaveContribution:
        "Failed to save contribution. Please try again.",
      // Guest name not required
      guestNameRequired: "Guest name is required",
      // Exchange rate form
      from: "From",
      to: "To",
      record: "Record",
      totalRecords: "Total",
      notificationLanguage: "Notification Language",
      notificationLanguageUpdated: "Notification Language updated successfully",
      failedToUpdateNotificationLanguage:
        "Failed to update notification language",
      messageAndSeoConfig: "Message & SEO Config",
      guestInviteMessage: "Guest Invite Message",
      invitationTemplate: "Invitation Representative",
      invitationTemplates: "Invitation Representative",
      invitationRepresentative: "Invitation Representative",
      invitationTemplateSubtitle: "Messages by sender representative (Parents or Family)",
      invitationRepresentativeSubtitle: "Messages by sender representative (Parents or Family)",
      representative: "Representative",
      defaultInvitationMessage: "Default",
      coupleInvitation: "Host",
      couple: "Couple",
      selectInvitationTemplate: "Select Representative",
      parentsInvitation: "Parents' Invitation",
      familyInvitation: "Family's Invitation",
      senderType: "Sender Type",
      labelKh: "Khmer Label",
      labelEn: "English Label",
      tapToInsertPlaceholder: "Tap to insert placeholder",
      addInvitationTemplate: "Add Another Sender Representative (PARENTS / FAMILY)",
      noInvitationTemplates: "No invitation representatives configured yet",
      noInvitationTemplatesDesc: "Configure sender-specific representatives for Parents or Family",
      configureTemplates: "Configure Representatives",
      invitationTemplatesSavedSuccess: "Invitation representatives updated successfully",
      invitationTemplatesSaveError: "Failed to update invitation representatives",
      confirmDeleteTemplate: "Delete Invitation Representative?",
      confirmDeleteTemplateDesc: "Are you sure you want to remove this invitation representative?",
      confirmClearAllTemplates: "Clear All Invitation Representatives?",
      confirmClearAllTemplatesDesc: "This will clear all representatives to empty list []. Saving will update the configuration on the server.",
      linkPreviewTitle: "Link Preview Title",
      linkPreviewDescription: "Link Preview Description",
      guestInviteMessageDesc: "Customize invitation message for Telegram chat",
      linkPreviewTitleDesc: "Customize link preview title & description for social sharing",
      saveGuestInviteSuccess: "Guest invite message updated successfully",
      saveLinkPreviewSuccess: "Link preview configuration updated successfully",
      resetToDefault: "Reset to Default",
      resetToDefaultSuccess: "Reset to default template successfully",
      invitationMessage: "Invitation Message",
      seoMessage: "SEO Message",
      seoTitle: "SEO Title",
      seoDescription: "SEO Description",
      saveMessagesSuccess: "Message & SEO configuration updated successfully",
      failedToLoadMessages: "Failed to load message & SEO configuration",
      saveMessagesError: "Failed to update message & SEO configuration",
      languageEn: "English",
      languageKh: "Khmer",
      languageCh: "Chinese",
      // Contact Us
      feedback: "Feedback",
      selectTopic: "Select Topic",
      generalQuestion: "General Question",
      partnership: "Partnership",
      feedbackTab: "Feedback",
      phoneNumber: "Phone Number",
      companyName: "Company Name",
      inquiryTopic: "Inquiry Topic",
      partnershipType: "Partnership Type",
      feedbackType: "Feedback Type",
      ratingLabel: "Rating",
      howCanWeHelp: "How Can We Help?",
      proposalDetails: "Proposal Details",
      yourFeedback: "Your Feedback / Suggestions",
      submitMessage: "Submit",
      submitSuccess: "Thank you! Your message has been sent successfully.",
      submitError: "Submission failed. Please try again.",
      optional: "Optional",
      required: "Required",
      pricingPackages: "Pricing & Packages",
      customDesignTheme: "Custom Design & Theme",
      guestListQR: "Guest List & QR Code",
      technicalAccountHelp: "Technical & Account Help",
      otherQuestion: "Other Question",
      eventPlannerAgency: "Event Planner / Agency",
      designerArtist: "Designer & Artist",
      vendorSponsor: "Vendor & Sponsor",
      affiliateReseller: "Affiliate & Reseller",
      otherCollaboration: "Other Collaboration",
      testimonial: "Testimonial",
      suggestion: "Suggestion",
      issueReport: "Issue Report",
      emailUs: "Email Us",
      callUs: "Call Us",
      visitUs: "Visit Us",
      companyAddress: "Street 1984, Phnom Penh, Cambodia",
      typicalResponseTime: "Typical response time: within 2 hours",
      fullNameRequired: "Full name is required",
      emailRequired: "Email is required",
      emailInvalid: "Please enter a valid email",
      messageRequired: "Message is required",
      phoneMinLength: "Phone number must be at least 6 digits",
      phoneMaxLength: "Phone number cannot exceed 12 digits",
      companyNameRequired: "Company name is required",
      // Thank You Message
      thankYouMessage: "Thank You Message",
      thankYouSubtitle: "Customize thank-you media & note shown to guests",
      thankYouPhotoTitle: "THANK YOU PHOTO",
      thankYouVideoLinkTitle: "VIDEO MESSAGE LINK (OPTIONAL)",
      thankYouMessageTextTitle: "THANK YOU MESSAGE TEXT",
      thankYouImage: "Thank You Image",
      thankYouVideoLink: "Thank You Video Link",
      message: "Message",
      messageKh: "Message (KH)",
      messageEn: "Message (EN)",
      messageCh: "Message (CH)",
      thankYouSaveSuccess: "Thank you message saved successfully",
      thankYouSaveError: "Failed to save thank you message",
      uploadThankYouPhoto: "Upload Thank You Photo",
      uploadImage: "Upload Image",
      changeImage: "Change Image",
      removeImage: "Remove Image",
      uploading: "Uploading...",
      uploadFailed: "Upload failed",
      fileUploadedSuccessfully: "Image uploaded successfully",
      mediaDeletedSuccessfully: "Image deleted successfully",
      // SEO Preview Enhancement
      editMode: "Edit",
      previewMode: "Preview",
      socialSharePreview: "Social Media Share Preview",
      invitationMessagePreview: "Invitation Message Preview",
      noImageSelected: "No Image Selected",
      eventInvitation: "Event Invitation",
      pleaseAttendOurSpecialDay: "Please attend our special day",
      enterInvitationMessage:
        "Enter an invitation message to see dynamic preview",
      // User Guide
      userGuide: "User Guides",
      userGuideTitle: "User Guides",
      userGuideSubtitle: "Learn how to set up and manage your digital invitation",
      searchGuidePlaceholder: "Search guides by title, feature, or event...",
      gettingStarted: "Getting Started",
      gettingStartedDesc: "Getting started tutorial video will be available soon.",
      noGettingStartedVideo: "No getting started video currently available.",
      guidesByEvent: "Guides by Event",
      guidesByEventDesc: "Select an event type to view specialized tutorial videos.",
      allEvents: "All Events",
      featureGuides: "Feature Guides",
      featureGuidesDesc: "Learn how to manage guests, RSVPs, contributions, wishes, and settings.",
      watchGuide: "Watch Guide",
      viewGuides: "View Guides",
      exploreTutorials: "Explore setup tutorials & tips",
      prevVideo: "Previous Video",
      nextVideo: "Next Video",
      videoCounter: "{{current}} / {{total}} Videos",
      upNext: "Up Next ({{count}})",
      part: "Part #{{number}}",
      partGuide: "Part #{{order}} • E-THEAP Guide",
      noEventGuidesTitle: "No event guides available",
      noEventGuidesDesc: "There are no guide videos listed for this event type yet.",
      noFeatureGuidesTitle: "No feature guides available",
      noFeatureGuidesDesc: "Check back soon for new feature tutorials.",
      noGuidesForEventDesc: "No videos listed for this event yet.",
    },
  },
  ch: {
    translation: {
      ...leadTranslations.ch,
      telegramActivation: "Telegram 激活",
      telegramActivationUnavailable: "暂时无法激活",
      telegramConnected: "Telegram 已连接",
      telegramNotConnected: "Telegram 未连接",
      revealActivationCode: "显示激活码",
      hideActivationCode: "隐藏激活码",
      copyActivationCode: "复制激活码",
      activationCodeLabel: "激活码",
      activationCodeCopied: "激活码已复制",
      activationCodeCopyFailed: "无法复制激活码，请重试。",
      back: "返回",
      language: "语言",
      selectLanguage: "选择语言",
      themeMode: "主题",
      lightMode: "浅色模式",
      darkMode: "深色模式",
      title: "标题",
      dueDate: "截止日期",
      saleManagement: "销售管理",
      allSales: "所有销售",
      allStatus: "所有状态",
      newSale: "新建销售",
      quickSetup: "快速设置",
      salePending: "待处理",
      saleView: "查看",
      saleDeposit: "定金",
      saleFinalPayment: "尾款",
      saleMissingCount: "缺少 {{count}} 项",
      saleFieldsComplete: "所有字段已填写",
      saleCompletionCounts: "✓ {{completed}} 项已完成 · ○ {{missing}} 项缺失",
      saleFilledValue: "已填写",
      saleMissingValue: "缺失",
      saleChecklistLoading: "正在加载清单…",
      saleChecklistUnavailable: "没有可检查的字段",
      saleDetailsFailed: "无法加载销售详情。",
      saleDetails: "销售详情",
      salePaymentSummary: "付款摘要",
      saleRetry: "重试",
      saleInProgress: "进行中",
      saleDone: "已完成",
      startSale: "开始处理",
      completeSale: "标记为完成",
      saleStatusUpdated: "销售状态已更新",
      saleStatusUpdateFailed: "无法更新销售状态，请重试。",
      saleUnassigned: "未分配",
      saleUnknownUser: "未知用户",
      saleNoPayment: "未付款",
      salePartialPayment: "部分付款",
      saleCompletePayment: "已付款",
      loadingPlans: "正在加载套餐…",
      loadPlansFailed: "无法加载套餐，请重新选择活动类型。",
      noEventPlans: "此活动类型尚未配置套餐。",
      general: "基本信息",
      eventDetail: "活动详情",
      setupDescription: "选择语言和活动，然后填写详情。",
      chooseEventFirst: "请选择活动类型以开始。",
      noEventFields: "此活动无需额外信息。",
      eventType: "活动类型",
      plan: "套餐",
      assignee: "负责人",
      you: "您",
      remark: "备注",
      createSale: "创建销售",
      editSale: "编辑销售",
      summaryInformation: "信息摘要",
      permissionsLoading: "正在加载权限…",
      permissionsUnavailable: "无法获取权限。在验证会话之前无法访问。",
      permissionPageDenied: "您没有查看此页面的权限。",
      permissionReadOnly: "只读：您的账户无法编辑此记录。",
      permissionAssignees: "加载负责人选项需要创建或更新任务的权限。",
      imagePreviewFailed: "无法加载图片。",
      imagePreviewLoading: "正在加载图片…",
      uploadImageConfirm: "上传",
      openDatePicker: "打开日期选择器",
      openTimePicker: "打开时间选择器",
      pasteImage: "粘贴图片",
      imageClipboardEmpty: "剪贴板中没有图片。请复制图片后重试。",
      imageClipboardUnavailable: "无法访问剪贴板或权限被拒绝。请直接粘贴到字段中，或保存图片后上传。",
      imagePasteHint: "复制图片后，选中此字段并粘贴即可上传。",
      customListAddItem: "添加项目",
      customListEmpty: "暂无项目。点击下方按钮添加项目。",
      summaryInformationSaved: "摘要信息已保存。",
      summaryInformationSaveFailed: "摘要信息保存失败，请重试。",
      save: "保存",
      cancel: "取消",
      continueWithTelegram: "使用 Telegram 继续",
      telegramConnecting: "正在连接 Telegram...",
      telegramOpenApp: "请在 Telegram 中打开 Sale Support。",
      telegramLoginFailed: "登录失败，请重试。",
      unauthorizedAccess: "未经授权的访问",
      telegramUnauthorizedMsg: "认证错误：Telegram 凭据无效",
      telegramUnauthorizedHint: "该 Telegram 账号未注册、未激活或未绑定。请将您的 Telegram ID 发送给管理员以获取访问权限。",
      tryAgain: "重试",
      closeApp: "关闭应用",
    },
  },
  kh: {
    translation: {
      ...leadTranslations.kh,
      telegramActivation: "ការភ្ជាប់ Telegram",
      telegramActivationUnavailable: "មិនអាចភ្ជាប់បាន",
      telegramConnected: "បានភ្ជាប់ Telegram",
      telegramNotConnected: "មិនទាន់ភ្ជាប់ Telegram",
      revealActivationCode: "បង្ហាញលេខកូដ",
      hideActivationCode: "លាក់លេខកូដ",
      copyActivationCode: "ចម្លងលេខកូដ",
      activationCodeLabel: "លេខកូដដំណើរការ",
      activationCodeCopied: "បានចម្លងលេខកូដ",
      activationCodeCopyFailed: "មិនអាចចម្លងលេខកូដបានទេ។ សូមព្យាយាមម្តងទៀត។",
      info: "ព័ត៌មាន",
      scan: "ស្កេន",
      add: "បន្ថែម",
      dashboard: "ផ្ទាំងគ្រប់គ្រង",
      manageUser: "គ្រប់គ្រងអ្នកប្រើប្រាស់",
      userProfile: "ប្រវត្តិរូបអ្នកប្រើប្រាស់",
      manageGuest: "គ្រប់គ្រងភ្ញៀវ",
      rsvp: "សារពីភ្ញៀវ",
      guestContribution: "ការចូលរួមពីភ្ញៀវ",
      report: "របាយការណ៍",
      scanQRCode: "ស្កេន QR កូដ",
      close: "បិទ",
      noCamera: "មិនមានកាមេរ៉ា",
      cameraPermissionDenied: "មិនអនុញ្ញាតឱ្យប្រើកាមេរ៉ា",
      addGuest: "បន្ថែមភ្ញៀវ",
      eventManagement: "ការគ្រប់គ្រងកម្មវិធី",
      guestActivities: "សកម្មភាពភ្ញៀវ និងការឆ្លើយតប",
      preferencesAndSupport: "ការកំណត់ និងជំនួយ",
      session: "គណនី",
      appearance: "រូបរាង",
      themeMode: "ទម្រង់ពន្លឺ/ងងឹត",
      darkMode: "ទម្រង់ងងឹត",
      lightMode: "ទម្រង់ពន្លឺ",
      // Manage Guest Page
      total: "សរុប",
      invited: "បានអញ្ជើញ",
      notInvited: "មិនទាន់អញ្ជើញ",
      all: "ទាំងអស់",
      guestList: "បញ្ជីភ្ញៀវ",
      searchGuests: "ស្វែងរកភ្ញៀវ...",
      select: "ជ្រើសរើស",
      selectAll: "ជ្រើសរើសទាំងអស់",
      done: "រួចរាល់",
      noGuestsFound: "រកមិនឃើញភ្ញៀវ",
      changeStatus: "ប្តូរស្ថានភាព",
      actions: "សកម្មភាព",
      printQRCode: "បោះពុម្ព QR កូដ",
      delete: "លុប",
      edit: "កែសម្រួល",
      wishes: "សារ",
      wish: "សារ",
      cancel: "បោះបង់",
      confirm: "បញ្ជាក់",
      save: "រក្សាទុក",
      tag: "ស្លាក",
      guestName: "ឈ្មោះភ្ញៀវ",
      guestNames: "ឈ្មោះភ្ញៀវ",
      guestNamesPlaceholder: "បញ្ចូលឈ្មោះភ្ញៀវ (មួយជួរមួយឈ្មោះ)",
      guestNamesHelper: "បញ្ចូលឈ្មោះភ្ញៀវនីមួយៗនៅលើជួរថ្មី",
      editGuest: "កែសម្រួលភ្ញៀវ",
      deleteGuest: "លុបភ្ញៀវ",
      deleteGuests: "លុបភ្ញៀវ",
      deleteGuestConfirm: "តើអ្នកប្រាកដថាចង់លុប {{name}} មែនទេ?",
      deleteGuestsConfirm: "តើអ្នកប្រាកដថាចង់លុបភ្ញៀវ {{count}} នាក់មែនទេ?",
      guestsCreated: "បានបង្កើតភ្ញៀវដោយជោគជ័យ",
      guestUpdated: "បានកែសម្រួលភ្ញៀវដោយជោគជ័យ",
      guestDeleted: "បានលុបភ្ញៀវដោយជោគជ័យ",
      guestsDeleted: "បានលុបភ្ញៀវ {{count}} នាក់ដោយជោគជ័យ",
      guestsStatusUpdated: "បានកែសម្រួលស្ថានភាពភ្ញៀវ {{count}} នាក់",
      fetchGuestsError: "មិនអាចទាញយកភ្ញៀវបានទេ",
      createGuestsError: "មិនអាចបង្កើតភ្ញៀវបានទេ",
      updateGuestError: "មិនអាចកែសម្រួលភ្ញៀវបានទេ",
      deleteGuestError: "មិនអាចលុបភ្ញៀវបានទេ",
      deleteGuestsError: "មិនអាចលុបភ្ញៀវបានទេ",
      updateGuestsStatusError: "មិនអាចកែសម្រួលស្ថានភាពភ្ញៀវបានទេ",
      printQRCodeFeature: "មុខងារបោះពុម្ព QR កូដនឹងមកដល់ឆាប់ៗនេះ",
      allTags: "ស្លាកទាំងអស់",
      searchByNameOrTag: "ស្វែងរកតាមឈ្មោះ ឬស្លាក...",
      searchByNameTagOrNote: "ស្វែងរកតាមឈ្មោះ ស្លាក ឬកំណត់ចំណាំ...",
      downloadQRCode: "ទាញយក QR កូដ",
      download: "ទាញយក",
      downloading: "កំពុងទាញយក...",
      invitationLink: "តំណភ្ជាប់អញ្ជើញ",
      shareVia: "ចែករំលែកតាម",
      invitationFor: "អញ្ជើញសម្រាប់",
      guestNotFound: "រកមិនឃើញភ្ញៀវ",
      wishesFrom: "សារពី",
      attend: "ចូលរួម",
      attendingGuests: "ចំនួនភ្ញៀវចូលរួម",
      yes: "បាទ/ចាស",
      no: "ទេ",
      show: "បង្ហាញ",
      hide: "លាក់",
      noWishesFound: "រកមិនឃើញសារ",
      noWishesDescription: "សូមព្យាយាមកែសម្រួលលក្ខខណ្ឌស្វែងរក ឬតម្រង",
      noGuestsDescription: "សូមព្យាយាមកែសម្រួលលក្ខខណ្ឌស្វែងរក ឬតម្រង",
      wishVisibilityUpdated: "ការមើលឃើញបំណងប្រាថ្នាត្រូវបានធ្វើបច្ចុប្បន្នភាព",
      wishVisibilityError:
        "បរាជ័យក្នុងការធ្វើបច្ចុប្បន្នភាពការមើលឃើញបំណងប្រាថ្នា",
      createdAt: "បង្កើតនៅ",
      updatedAt: "ធ្វើបច្ចុប្បន្នភាពនៅ",
      responseAt: "ឆ្លើយតបនៅ",
      // Bulk PrintGuestList: "បោះពុម្ពបញ្ជីភ្ញៀវ",
      settings: "ការកំណត់",
      guestNameSize: "ទំហំឈ្មោះភ្ញៀវ",
      qrCodeSize: "ទំហំ QR កូដ",
      fontSize: "ទំហំអក្សរ",
      width: "ទទឹង",
      height: "កម្ពស់",
      print: "បោះពុម្ព",
      totalGuests: "ភ្ញៀវសរុប",
      qrCodes: "QR កូដ",
      noGuestsSelected: "មិនបានជ្រើសរើសភ្ញៀវ",
      backToGuestList: "ត្រឡប់ទៅបញ្ជីភ្ញៀវ",
      small: "តូច",
      medium: "មធ្យម",
      large: "ធំ",
      custom: "ផ្ទាល់ខ្លួន",
      enterGuestName: "បញ្ចូលឈ្មោះភ្ញៀវ",
      selectOrCreateTag: "ជ្រើសរើស ឬបង្កើតស្លាក",
      mayBe: "ប្រហែល",
      notAttend: "មិនចូលរួម",
      notResponse: "មិនទាន់ឆ្លើយ",
      usd: "ដុល្លារ",
      khr: "រៀល",
      cash: "ប្រាក់",
      qrCode: "QR កូដ",
      QRCode: "QR កូដ",
      // Dashboard
      totalGuest: "ភ្ញៀវសរុប",
      totalWishes: "សារសរុប",
      notInvitedGuest: "ភ្ញៀវមិនទាន់អញ្ជើញ",
      totalGuestStatus: "ស្ថានភាពភ្ញៀវសរុប",
      totalGuestContribution: "ការចូលរួមពីភ្ញៀវសរុប",
      grandTotal: "សរុបរួម",
      attendGuest: "ភ្ញៀវចូលរួម",
      notAttendGuest: "ភ្ញៀវមិនចូលរួម",
      pendingResponse: "រង់ចាំការឆ្លើយតប",
      walkInGuest: "ភ្ញៀវចូលរួម",
      usdGuest: "ភ្ញៀវ USD",
      khrGuest: "ភ្ញៀវ KHR",
      // Report
      reportGuest: "របាយការណ៍ភ្ញៀវ",
      reportRSVP: "របាយការណ៍RSVP",
      reportContribution: "របាយការណ៍ការចូលរួម",
      addContribution: "បន្ថែមការចូលរួម",
      editContribution: "កែសម្រួលការចូលរួម",
      manageTags: "គ្រប់គ្រងស្លាក",
      reorderTags: "រៀបចំស្លាកឡើងវិញ",
      reorderTagsDescription: "អូសចំណុចទាញដើម្បីរៀបចំលំដាប់ស្លាកឡើងវិញ",
      tagsReorderedSuccessfully: "បានរៀបចំស្លាកឡើងវិញដោយជោគជ័យ",
      failedToReorderTags: "បរាជ័យក្នុងការរៀបចំស្លាកឡើងវិញ",
      moveUp: "រំកិលឡើងលើ",
      moveDown: "រំកិលចុះក្រោម",
      addTag: "បន្ថែមស្លាក",
      editTag: "កែសម្រួលស្លាក",
      tagName: "ឈ្មោះស្លាក",
      enterTagName: "បញ្ចូលឈ្មោះស្លាក",
      noTagsYet: "មិនទាន់មានស្លាកនៅឡើយទេ។ បង្កើតស្លាកដំបូងរបស់អ្នក!",
      deleteContributionConfirm:
        "តើអ្នកប្រាកដថាចង់លុបការចូលរួមពី {{name}} មែនទេ?",
      contributionDeleted: "បានលុបការចូលរួម",
      contributionDeletedSuccess: "ការចូលរួមត្រូវបានលុបដោយជោគជ័យ",
      deleteFailed: "លុបមិនបានជោគជ័យ",
      deleteFailedDescription: "មិនអាចលុបការចូលរួមបានទេ។ សូមព្យាយាមម្តងទៀត។",
      noContributionsFound: "រកមិនឃើញការចូលរួម",
      noContributionsDescription: "សូមព្យាយាមកែសម្រួលលក្ខខណ្ឌស្វែងរក ឬតម្រង",
      amountMustBePositive: "ចំនួនទឹកប្រាក់ត្រូវតែធំជាង 0",
      currencyRequired: "ត្រូវការរូបិយប័ណ្ណ",
      selectCurrency: "ជ្រើសរើសរូបិយប័ណ្ណ",
      noContributions: "មិនទាន់មានការចូលរួមនៅឡើយទេ",
      create: "បង្កើត",
      update: "ធ្វើបច្ចុប្បន្នភាព",
      selectLanguage: "ជ្រើសរើសភាសា",
      back: "ត្រឡប់ក្រោយ",
      quickSetup: "រៀបចំរហ័ស",
      salePending: "រង់ចាំ",
      saleView: "មើល",
      saleDeposit: "ប្រាក់កក់",
      saleFinalPayment: "ប្រាក់ទូទាត់ចុងក្រោយ",
      saleMissingCount: "ខ្វះព័ត៌មាន {{count}}",
      saleFieldsComplete: "បានបំពេញគ្រប់ព័ត៌មាន",
      saleCompletionCounts: "✓ បានបំពេញ {{completed}} · ○ ខ្វះ {{missing}}",
      saleFilledValue: "បានបំពេញ",
      saleMissingValue: "ខ្វះ",
      saleChecklistLoading: "កំពុងផ្ទុកបញ្ជីត្រួតពិនិត្យ…",
      saleChecklistUnavailable: "គ្មានព័ត៌មានសម្រាប់ត្រួតពិនិត្យ",
      saleDetailsFailed: "មិនអាចផ្ទុកព័ត៌មានលម្អិតការលក់បានទេ។",
      saleDetails: "ព័ត៌មានលម្អិតការលក់",
      salePaymentSummary: "សង្ខេបការបង់ប្រាក់",
      saleRetry: "ព្យាយាមម្ដងទៀត",
      saleInProgress: "កំពុងដំណើរការ",
      saleDone: "រួចរាល់",
      startSale: "ចាប់ផ្តើមការលក់",
      completeSale: "សម្គាល់ថារួចរាល់",
      saleStatusUpdated: "បានធ្វើបច្ចុប្បន្នភាពស្ថានភាពការលក់",
      saleStatusUpdateFailed: "មិនអាចធ្វើបច្ចុប្បន្នភាពស្ថានភាពបានទេ។ សូមព្យាយាមម្ដងទៀត។",
      saleUnassigned: "មិនទាន់កំណត់អ្នកទទួលបន្ទុក",
      saleUnknownUser: "អ្នកប្រើប្រាស់មិនស្គាល់",
      saleNoPayment: "មិនទាន់បង់ប្រាក់",
      salePartialPayment: "បានបង់មួយផ្នែក",
      saleCompletePayment: "បានបង់ប្រាក់",
      loadingPlans: "កំពុងផ្ទុកកញ្ចប់…",
      loadPlansFailed: "មិនអាចផ្ទុកកញ្ចប់បានទេ។ សូមជ្រើសរើសប្រភេទកម្មវិធីម្ដងទៀត។",
      noEventPlans: "ប្រភេទកម្មវិធីនេះមិនទាន់មានកញ្ចប់ទេ។",
      general: "ព័ត៌មានទូទៅ",
      eventDetail: "ព័ត៌មានកម្មវិធី",
      setupDescription: "ជ្រើសរើសភាសា និងកម្មវិធី រួចបំពេញព័ត៌មានលម្អិត។",
      chooseEventFirst: "ជ្រើសរើសប្រភេទកម្មវិធីដើម្បីចាប់ផ្តើម។",
      noEventFields: "កម្មវិធីនេះមិនត្រូវការព័ត៌មានបន្ថែមទេ។",
      plan: "កញ្ចប់",
      assignee: "អ្នកទទួលបន្ទុក",
      you: "អ្នក",
      remark: "កំណត់សម្គាល់",
      createSale: "បង្កើតការលក់",
      editSale: "កែសម្រួលការលក់",
      summaryInformation: "ព័ត៌មានសង្ខេប",
      permissionsLoading: "កំពុងផ្ទុកសិទ្ធិ…",
      permissionsUnavailable: "មិនអាចទទួលបានសិទ្ធិ។ សូមផ្ទៀងផ្ទាត់គណនីមុនពេលចូលប្រើ។",
      permissionPageDenied: "អ្នកមិនមានសិទ្ធិមើលទំព័រនេះទេ។",
      permissionReadOnly: "បានត្រឹមមើល៖ គណនីរបស់អ្នកមិនអាចកែសម្រួលទិន្នន័យនេះបានទេ។",
      permissionAssignees: "ការផ្ទុកអ្នកទទួលបន្ទុកត្រូវការសិទ្ធិបង្កើត ឬកែសម្រួលការលក់។",
      imagePreviewFailed: "មិនអាចបង្ហាញរូបភាពបានទេ។",
      imagePreviewLoading: "កំពុងផ្ទុករូបភាព…",
      uploadImageConfirm: "ផ្ទុកឡើង",
      openDatePicker: "បើកប្រអប់ជ្រើសរើសកាលបរិច្ឆេទ",
      openTimePicker: "បើកប្រអប់ជ្រើសរើសម៉ោង",
      pasteImage: "បិទភ្ជាប់រូបភាព",
      imageClipboardEmpty: "រកមិនឃើញរូបភាពទេ។ សូមចម្លងរូបភាព ហើយព្យាយាមម្ដងទៀត។",
      imageClipboardUnavailable: "មិនអាចចូលប្រើក្ដារតម្បៀតខ្ទាស់បានទេ។ សូមបិទភ្ជាប់ក្នុងប្រអប់ដោយផ្ទាល់ ឬរក្សាទុករូបភាព រួចផ្ទុកឡើង។",
      imagePasteHint: "ចម្លងរូបភាព រួចជ្រើសរើសប្រអប់នេះ ហើយបិទភ្ជាប់ដើម្បីផ្ទុកឡើង។",
      customListAddItem: "បន្ថែមធាតុ",
      customListEmpty: "មិនទាន់មានធាតុទេ។ ចុចប៊ូតុងខាងក្រោមដើម្បីបន្ថែមធាតុ។",
      summaryInformationSaved: "បានរក្សាទុកព័ត៌មានសង្ខេបដោយជោគជ័យ។",
      summaryInformationSaveFailed: "មិនអាចរក្សាទុកព័ត៌មានសង្ខេបបានទេ។ សូមព្យាយាមម្ដងទៀត។",
      continueWithTelegram: "បន្តជាមួយ Telegram",
      telegramConnecting: "កំពុងភ្ជាប់ជាមួយ Telegram...",
      telegramOpenApp: "សូមបើក Sale Support ក្នុង Telegram។",
      telegramLoginFailed: "មិនអាចចូលបានទេ។ សូមព្យាយាមម្ដងទៀត។",
      unauthorizedAccess: "គ្មានសិទ្ធិចូលប្រើ",
      telegramUnauthorizedMsg: "កំហុសផ្ទៀងផ្ទាត់៖ ព័ត៌មានសម្ងាត់ Telegram មិនត្រឹមត្រូវ",
      telegramUnauthorizedHint: "គណនី Telegram នេះមិនទាន់បានចុះឈ្មោះ អសកម្ម ឬមិនទាន់ភ្ជាប់ទេ។ សូមផ្តល់ Telegram ID របស់អ្នកទៅអ្នកគ្រប់គ្រងដើម្បីបើកសិទ្ធិ។",
      tryAgain: "ព្យាយាមម្តងទៀត",
      closeApp: "បិទកម្មវិធី",
      title: "ចំណងជើង",
      dueDate: "កាលបរិច្ឆេទកំណត់",
      saleManagement: "គ្រប់គ្រងការលក់",
      allSales: "ការលក់ទាំងអស់",
      allStatus: "ស្ថានភាពទាំងអស់",
      newSale: "ការលក់ថ្មី",
      eventType: "ប្រភេទកម្មវិធី",
      language: "ភាសា",
      template: "ទម្រង់",
      detail: "លម្អិត",
      copied: "បានចម្លង",
      statusUpdated: "បានអញ្ជើញរួចរាល់",
      cancelStatus: "បោះបង់ការអញ្ជើញ",
      statusUpdateError: "បរាជ័យក្នុងការធ្វើបច្ចុប្បន្នភាពស្ថានភាព",
      quickSelect: "ជ្រើសរើសរហ័ស",
      tagNames: "ស្លាក​ជាច្រើន",
      other: "ផ្សេងទៀត",
      // User Profile
      profileNotFound: "រកមិនឃើញប្រវត្តិរូប",
      fullName: "ឈ្មោះពេញ",
      email: "អ៊ីមែល",
      phone: "លេខទូរស័ព្ទ",
      role: "តួនាទី",
      status: "ស្ថានភាព",
      active: "សកម្ម",
      inactive: "អសកម្ម",
      memberSince: "សមាជិកតាំងពី",
      lastUpdated: "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ",
      // Import/Export
      downloadTemplate: "ទាញយកគំរូ",
      uploadGuests: "បញ្ចូលភ្ញៀវ",
      exportGuests: "នាំចេញភ្ញៀវ",
      templateDownloaded: "បានទាញយកគំរូដោយជោគជ័យ",
      downloadTemplateFailed: "បរាជ័យក្នុងការទាញយកគំរូ",
      guestsUploadedSuccessfully: "បានបញ្ចូលភ្ញៀវដោយជោគជ័យ",
      uploadGuestsFailed: "បរាជ័យក្នុងការបញ្ចូលភ្ញៀវ",
      guestsExportedSuccessfully: "បាននាំចេញភ្ញៀវដោយជោគជ័យ",
      exportGuestsFailed: "បរាជ័យក្នុងការនាំចេញភ្ញៀវ",
      export: "ទាញយក",
      exporting: "កំពុងទាញយក...",
      logout: "ចាកចេញ",
      filter: "ស្វែងរក",
      filterByTags: "ជ្រើសរើសតាមស្លាក",
      share: "ចែករំលែក",
      visibility: "បង្ហាញ",
      setting: "ការកំណត់",
      currency: "រូបិយប័ណ្ណ",
      exchangeRate: "អត្រាប្តូរប្រាក់",
      addCurrency: "បន្ថែមរូបិយប័ណ្ណ",
      editCurrency: "កែសម្រួលរូបិយប័ណ្ណ",
      currencyCode: "លេខកូដរូបិយប័ណ្ណ",
      currencyName: "ឈ្មោះរូបិយប័ណ្ណ",
      noCurrenciesFound: "រកមិនឃើញរូបិយប័ណ្ណ",
      currencyCreatedSuccessfully: "បានបង្កើតរូបិយប័ណ្ណដោយជោគជ័យ",
      currencyUpdatedSuccessfully: "បានកែសម្រួលរូបិយប័ណ្ណដោយជោគជ័យ",
      currencyDeletedSuccessfully: "បានលុបរូបិយប័ណ្ណដោយជោគជ័យ",
      failedToLoadCurrencies: "មិនអាចទាញយករូបិយប័ណ្ណបានទេ",
      addExchangeRate: "បន្ថែមអត្រាប្តូរប្រាក់",
      editExchangeRate: "កែសម្រួលអត្រាប្តូរប្រាក់",
      rate: "អត្រា",
      noExchangeRatesFound: "រកមិនឃើញអត្រាប្តូរប្រាក់",
      exchangeRateCreatedSuccessfully: "បានបង្កើតអត្រាប្តូរប្រាក់ដោយជោគជ័យ",
      exchangeRateUpdatedSuccessfully: "បានកែសម្រួលអត្រាប្តូរប្រាក់ដោយជោគជ័យ",
      exchangeRateDeletedSuccessfully: "បានលុបអត្រាប្តូរប្រាក់ដោយជោគជ័យ",
      failedToLoadExchangeRates: "មិនអាចទាញយកអត្រាប្តូរប្រាក់បានទេ",
      confirmDeleteWithName: "តើអ្នកប្រាកដថាចង់លុប {{name}} មែនទេ?",
      pleaseCompleteAllFields: "សូមបំពេញព័ត៌មានទាំងអស់",
      operationFailed: "ប្រតិបត្តិការបរាជ័យ",
      confirmDelete: "តើអ្នកប្រាកដថាចង់លុបវាមែនទេ?",
      // Guest Detail
      contributionNotFound: "រកមិនឃើញការចូលរួម",
      guestDetail: "ព័ត៌មានភ្ញៀវ",
      userName: "ឈ្មោះអ្នកប្រើ",
      invitedAt: "អញ្ជើញនៅ",
      rsvpSummary: "សង្ខេប RSVP",
      respondedAt: "ឆ្លើយតបនៅ",
      guestWishes: "សារភ្ញៀវ",
      contributionSummary: "សង្ខេបការចូលរួម",
      paymentAt: "បង់ប្រាក់នៅ",
      paymentType: "ប្រភេទការបង់ប្រាក់",
      currencyType: "ប្រភេទរូបិយប័ណ្ណ",
      amount: "ចំនួនទឹកប្រាក់",
      guestNote: "កំណត់ចំណាំ",
      walkIn: "ភ្ញៀវផ្ទាល់",
      enterName: "បញ្ចូលឈ្មោះ",
      enterNote: "បញ្ចូលចំណាំ",
      // ManageTags
      validationError: "កំហុសក្នុងការផ្ទៀងផ្ទាត់",
      tagNameRequired: "ត្រូវការឈ្មោះស្លាក",
      duplicateTag: "ស្លាកស្ទួន",
      tagAlreadyExists: "ស្លាកនេះមានរួចហើយ",
      tagUpdatedSuccessfully: "បានកែសម្រួលស្លាកដោយជោគជ័យ",
      tagCreatedSuccessfully: "បានបង្កើតស្លាកដោយជោគជ័យ",
      tagDeleted: "បានលុបស្លាក",
      tagDeletedSuccess: 'ស្លាក "{{name}}" ត្រូវបានលុបដោយជោគជ័យ',
      tagDeleteFailed: "លុបស្លាកបរាជ័យ",
      tagDeleteFailedDescription: "មិនអាចលុបស្លាកបានទេ។ សូមព្យាយាមម្តងទៀត។",
      failedToUpdateTag: "មិនអាចកែសម្រួលស្លាកបានទេ។ សូមព្យាយាមម្តងទៀត។",
      failedToCreateTag: "មិនអាចបង្កើតស្លាកបានទេ។ សូមព្យាយាមម្តងទៀត។",
      deleteTagConfirm: 'តើអ្នកប្រាកដថាចង់លុបស្លាក "{{name}}" មែនទេ?',
      // Contribution Form
      failedToLoadGuestFromQR: "មិនអាចទាញយកភ្ញៀវវាពី QR កូដបានទេ",
      pleaseRetryAgain: "សូមព្យាយាមម្តងទៀត",
      contributionUpdatedSuccessfully: "បានកែសម្រួលដោយជោគជ័យ!",
      contributionSavedSuccessfully: "បានរក្សាទុកដោយជោគជ័យ!",
      failedToUpdateContribution:
        "មិនអាចកែសម្រួលការចូលរួមបានទេ។ សូមព្យាយាមម្តងទៀត។",
      failedToSaveContribution:
        "មិនអាចរក្សាទុកការចូលរួមបានទេ។ សូមព្យាយាមម្តងទៀត។",
      // Guest name not required
      guestNameRequired: "ត្រូវការឈ្មោះភ្ញៀវ",
      // Exchange rate form
      from: "ពី",
      to: "ទៅ",
      record: "កត់ចំណងដៃ",
      totalRecords: "សរុប",
      notificationLanguage: "ភាសាដែលទទួលការជូនដំណឹង",
      notificationLanguageUpdated:
        "បានកែសម្រួលភាសាដែលចង់ទទួលការជូនដំណឹងដោយជោគជ័យ",
      failedToUpdateNotificationLanguage: "មិនអាចកែសម្រួលភាសាដែលចង់បានទេ",
      messageAndSeoConfig: "ការកំណត់សារ & SEO",
      guestInviteMessage: "សារអញ្ជើញភ្ញៀវ",
      invitationTemplate: "តំណាងអ្នកអញ្ជើញ",
      invitationTemplates: "តំណាងអ្នកអញ្ជើញ",
      invitationRepresentative: "តំណាងអ្នកអញ្ជើញ",
      invitationTemplateSubtitle: "សារអញ្ជើញតាមតំណាងអ្នកផ្ញើ (ឪពុកម្តាយ ឬ ក្រុមគ្រួសារ)",
      invitationRepresentativeSubtitle: "សារអញ្ជើញតាមតំណាងអ្នកផ្ញើ (ឪពុកម្តាយ ឬ ក្រុមគ្រួសារ)",
      representative: "តំណាង",
      defaultInvitationMessage: "លំនាំដើម",
      coupleInvitation: "សាមីខ្លួន",
      couple: "គូស្វាមីភរិយា",
      selectInvitationTemplate: "ជ្រើសរើសតំណាងអ្នកអញ្ជើញ",
      parentsInvitation: "លិខិតអញ្ជើញពីឪពុកម្តាយ",
      familyInvitation: "លិខិតអញ្ជើញពីក្រុមគ្រួសារ",
      senderType: "ប្រភេទអ្នកផ្ញើ",
      labelKh: "ស្លាកភាសាខ្មែរ",
      labelEn: "ស្លាកភាសាអង់គ្លេស",
      tapToInsertPlaceholder: "ចុចដើម្បីបញ្ចូលអថេរ",
      addInvitationTemplate: "បន្ថែមតំណាងអ្នកផ្ញើថ្មី (PARENTS / FAMILY)",
      noInvitationTemplates: "មិនទាន់មានកំណត់តំណាងអ្នកអញ្ជើញនៅឡើយទេ",
      noInvitationTemplatesDesc: "កំណត់សារអញ្ជើញតាមតំណាងអ្នកផ្ញើជាឪពុកម្តាយ ឬ ក្រុមគ្រួសារ",
      configureTemplates: "កំណត់តំណាងអ្នកផ្ញើ",
      invitationTemplatesSavedSuccess: "បានធ្វើបច្ចុប្បន្នភាពតំណាងអ្នកអញ្ជើញដោយជោគជ័យ",
      invitationTemplatesSaveError: "មិនអាចធ្វើបច្ចុប្បន្នភាពតំណាងអ្នកអញ្ជើញបានទេ",
      confirmDeleteTemplate: "តើអ្នកពិតជាចង់លុបតំណាងអ្នកអញ្ជើញនេះមែនទេ?",
      confirmDeleteTemplateDesc: "តើអ្នកប្រាកដថាចង់លុបតំណាងអ្នកអញ្ជើញនេះចេញពីបញ្ជីមែនទេ?",
      confirmClearAllTemplates: "សម្អាតតំណាងអ្នកអញ្ជើញទាំងអស់?",
      confirmClearAllTemplatesDesc: "សកម្មភាពនេះនឹងកំណត់តំណាងអ្នកអញ្ជើញទាំងអស់ទៅជាទទេ []។ ចុចរក្សាទុកដើម្បីធ្វើបច្ចុប្បន្នភាពទៅកាន់ម៉ាស៊ីនបម្រើ។",
      linkPreviewTitle: "ចំណងជើងតំណចែករំលែក",
      linkPreviewDescription: "ការពិពណ៌នាតំណចែករំលែក",
      guestInviteMessageDesc: "កែសម្រួលសារអញ្ជើញសម្រាប់ផ្ញើលើតេឡេក្រាម",
      linkPreviewTitleDesc: "កែសម្រួលចំណងជើង និងការពិពណ៌នានៃតំណចែករំលែក",
      saveGuestInviteSuccess: "បានធ្វើបច្ចុប្បន្នភាពសារអញ្ជើញភ្ញៀវដោយជោគជ័យ",
      saveLinkPreviewSuccess: "បានធ្វើបច្ចុប្បន្នភាពចំណងជើងតំណចែករំលែកដោយជោគជ័យ",
      resetToDefault: "កំណត់ឡើងវិញតាមគំរូដើម",
      resetToDefaultSuccess: "បានកំណត់ឡើងវិញតាមគំរូដើមដោយជោគជ័យ",
      invitationMessage: "សារអញ្ជើញ",
      seoMessage: "សារ SEO",
      seoTitle: "ចំណងជើង SEO",
      seoDescription: "ការពិពណ៌នា SEO",
      saveMessagesSuccess: "បានធ្វើបច្ចុប្បន្នភាពសារ & SEO ដោយជោគជ័យ",
      failedToLoadMessages: "មិនអាចទាញយកព័ត៌មានការកំណត់សារ & SEO បានទេ",
      saveMessagesError: "មិនអាចធ្វើបច្ចុប្បន្នភាពការកំណត់សារ & SEO បានទេ",
      languageEn: "ភាសាអង់គ្លេស",
      languageKh: "ភាសាខ្មែរ",
      languageCh: "ភាសាចិន",
      // Contact Us
      feedback: "មតិយោបល់",
      selectTopic: "ជ្រើសរើសប្រធានបទ",
      generalQuestion: "សំណួរទូទៅ",
      partnership: "ភាពជាដៃគូ",
      feedbackTab: "មតិយោបល់",
      phoneNumber: "លេខទូរស័ព្ទ",
      companyName: "ឈ្មោះក្រុមហ៊ុន",
      inquiryTopic: "ប្រធានបទសំណួរ",
      partnershipType: "ប្រភេទភាពជាដៃគូ",
      feedbackType: "ប្រភេទមតិយោបល់",
      ratingLabel: "ការវាយតម្លៃ",
      howCanWeHelp: "តើយើងអាចជួយអ្វីបាន?",
      proposalDetails: "ព័ត៌មានលម្អិតអំពីសំណើ",
      yourFeedback: "មតិយោបល់ / ការណែនាំរបស់អ្នក",
      submitMessage: "បញ្ជូន",
      submitSuccess: "សូមអរគុណ! សាររបស់អ្នកត្រូវបានផ្ញើដោយជោគជ័យ។",
      submitError: "ការបញ្ជូនបរាជ័យ។ សូមព្យាយាមម្ដងទៀត។",
      optional: "ស្រេចចិត្ត",
      required: "ចាំបាច់",
      pricingPackages: "តម្លៃ និងកញ្ចប់",
      customDesignTheme: "រចនាតាមបំណង និងរចនាបទ",
      guestListQR: "បញ្ជីភ្ញៀវ និង QR កូដ",
      technicalAccountHelp: "ជំនួយបច្ចេកទេស និងគណនី",
      otherQuestion: "សំណួរផ្សេងៗ",
      eventPlannerAgency: "អ្នករៀបចំកម្មវិធី / ភ្នាក់ងារ",
      designerArtist: "អ្នករចនា និងសិល្បករ",
      vendorSponsor: "អ្នកផ្គត់ផ្គង់ និងអ្នកឧបត្ថម្ភ",
      affiliateReseller: "សម្ព័ន្ធ និងអ្នកលក់បន្ត",
      otherCollaboration: "កិច្ចសហការផ្សេងៗ",
      testimonial: "ការវាយតម្លៃ",
      suggestion: "ការណែនាំ",
      issueReport: "រាយការណ៍បញ្ហា",
      emailUs: "ផ្ញើអ៊ីមែល",
      callUs: "ហៅទូរស័ព្ទ",
      visitUs: "មកទស្សនា",
      companyAddress: "ផ្លូវ ១៩៨៤ ភ្នំពេញ កម្ពុជា",
      typicalResponseTime: "ពេលវេលាឆ្លើយតបធម្មតា: ក្នុងរយៈពេល ២ម៉ោង",
      fullNameRequired: "ត្រូវការឈ្មោះពេញ",
      emailRequired: "ត្រូវការអ៊ីមែល",
      emailInvalid: "សូមបញ្ចូលអ៊ីមែលត្រឹមត្រូវ",
      messageRequired: "ត្រូវការសារ",
      phoneMinLength: "លេខទូរស័ព្ទត្រូវមានយ៉ាងហោចណាស់ ៦ខ្ទង់",
      phoneMaxLength: "លេខទូរស័ព្ទមិនអាចលើសពី ១២ខ្ទង់ទេ",
      companyNameRequired: "ត្រូវការឈ្មោះក្រុមហ៊ុន",
      // Thank You Message
      thankYouMessage: "សារថ្លែងអំណរគុណ",
      thankYouSubtitle: "កំណត់រូបថត វីដេអូ និងសារថ្លែងអំណរគុណសម្រាប់ភ្ញៀវ",
      thankYouPhotoTitle: "រូបថតថ្លែងអំណរគុណ",
      thankYouVideoLinkTitle: "តំណវីដេអូថ្លែងអំណរគុណ (ជម្រើស)",
      thankYouMessageTextTitle: "អត្ថបទសារថ្លែងអំណរគុណ",
      thankYouImage: "រូបភាពថ្លែងអំណរគុណ",
      thankYouVideoLink: "តំណវីដេអូថ្លែងអំណរគុណ",
      message: "សារ",
      messageKh: "សារ (ខ្មែរ)",
      messageEn: "សារ (អង់គ្លេស)",
      messageCh: "សារ (ចិន)",
      thankYouSaveSuccess: "បានរក្សាទុកសារថ្លែងអំណរគុណដោយជោគជ័យ",
      thankYouSaveError: "បរាជ័យក្នុងការរក្សាទុកសារថ្លែងអំណរគុណ",
      uploadThankYouPhoto: "បញ្ចូលរូបថតថ្លែងអំណរគុណ",
      uploadImage: "បញ្ចូលរូបភាព",
      changeImage: "ផ្លាស់ប្ដូររូបភាព",
      removeImage: "លុបរូបភាព",
      uploading: "កំពុងបញ្ចូល...",
      uploadFailed: "បរាជ័យក្នុងការបញ្ចូល",
      fileUploadedSuccessfully: "បានបញ្ចូលរូបភាពដោយជោគជ័យ",
      mediaDeletedSuccessfully: "បានលុបរូបភាពដោយជោគជ័យ",
      // SEO Preview Enhancement
      editMode: "កែសម្រួល",
      previewMode: "មើលជាមុន",
      socialSharePreview: "មើលជាមុនការចែករំលែកបណ្ដាញសង្គម",
      invitationMessagePreview: "មើលជាមុនសារអញ្ជើញ",
      noImageSelected: "គ្មានរូបភាពត្រូវបានជ្រើសរើស",
      eventInvitation: "ការអញ្ជើញចូលរួមកម្មវិធី",
      pleaseAttendOurSpecialDay: "សូមអញ្ជើញចូលរួមកម្មវិធីពិសេសរបស់យើង",
      enterInvitationMessage: "បញ្ចូលសារអញ្ជើញដើម្បីមើលជាមុន",
      // User Guide
      userGuide: "របៀបប្រើប្រាស់",
      userGuideTitle: "របៀបប្រើប្រាស់",
      userGuideSubtitle: "រៀនពីរបៀបរៀបចំ និងគ្រប់គ្រងលិខិតអញ្ជើញឌីជីថលរបស់អ្នក។",
      searchGuidePlaceholder: "ស្វែងរករបៀបប្រើប្រាស់តាមចំណងជើង មុខងារ ឬកម្មវិធី...",
      gettingStarted: "ចាប់ផ្តើមដំបូង",
      gettingStartedDesc: "វីដេអូបង្រៀនចាប់ផ្តើមដំបូងនឹងមានក្នុងពេលឆាប់ៗនេះ។",
      noGettingStartedVideo: "មិនទាន់មានវីដេអូចាប់ផ្តើមដំបូងនៅឡើយទេ។",
      guidesByEvent: "របៀបប្រើប្រាស់តាមកម្មវិធី",
      guidesByEventDesc: "ជ្រើសរើសប្រភេទកម្មវិធីដើម្បីមើលវីដេអូបង្រៀនជាក់លាក់។",
      allEvents: "កម្មវិធីទាំងអស់",
      featureGuides: "របៀបប្រើប្រាស់មុខងារ",
      featureGuidesDesc: "រៀនពីរបៀបគ្រប់គ្រងភ្ញៀវ, ការឆ្លើយតប RSVP, ចំណងដៃ, ពរជ័យ និងការកំណត់។",
      watchGuide: "ទស្សនារបៀបប្រើប្រាស់",
      viewGuides: "មើលរបៀបប្រើប្រាស់",
      exploreTutorials: "ស្វែងយល់ពីវីដេអូបង្រៀន និងគន្លឹះរៀបចំ",
      prevVideo: "វីដេអូមុន",
      nextVideo: "វីដេអូបន្ទាប់",
      videoCounter: "{{current}} / {{total}} វីដេអូ",
      upNext: "វីដេអូបន្ទាប់ ({{count}})",
      part: "ភាគទី {{number}}",
      partGuide: "ភាគទី {{order}} • របៀបប្រើប្រាស់ E-THEAP",
      noEventGuidesTitle: "មិនទាន់មានរបៀបប្រើប្រាស់តាមកម្មវិធីនៅឡើយទេ",
      noEventGuidesDesc: "មិនទាន់មានវីដេអូបង្រៀនសម្រាប់ប្រភេទកម្មវិធីនេះនៅឡើយទេ។",
      noFeatureGuidesTitle: "មិនទាន់មានរបៀបប្រើប្រាស់មុខងារនៅឡើយទេ",
      noFeatureGuidesDesc: "សូមត្រឡប់មកពិនិត្យមើលឡើងវិញក្នុងពេលឆាប់ៗសម្រាប់វីដេអូបង្រៀនមុខងារថ្មីៗ។",
      noGuidesForEventDesc: "មិនទាន់មានវីដេអូសម្រាប់កម្មវិធីនេះនៅឡើយទេ។",
    },
  },
};

const getStoredLanguage = async (): Promise<string> => {
  try {
    if (cloudStorage.isSupported()) {
      const storedLang = await cloudStorage.getItem(LANGUAGE_STORAGE_KEY);
      return storedLang || "en";
    }
  } catch (error) {
    console.warn("Failed to load language from CloudStorage:", error);
  }

  return localStorage.getItem(LANGUAGE_STORAGE_KEY) || "en";
};

const saveLanguage = async (language: string): Promise<void> => {
  try {
    if (cloudStorage.isSupported()) {
      await cloudStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    }
  } catch (error) {
    console.warn("Failed to save language to CloudStorage:", error);
  }

  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
};

getStoredLanguage().then((storedLanguage) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = storedLanguage;
  }
  i18n.use(initReactI18next).init({
    resources,
    lng: storedLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
});

i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
  }
  saveLanguage(lng);
});

export default i18n;
export { saveLanguage, getStoredLanguage };
